export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What is the term when memory, CPU, and storage are virtualized and allocated by the hypervisor?",
    "description": "Resource pooling."
  },
  {
    "id": 2,
    "topic_id": 2,
    "title": "What technology enables on-demand computing?",
    "description": "Virtualization."
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "What is a cloud service that provides a virtual server platform but not the operating system or applications?",
    "description": "IaaS."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What is a virtual network device that connects virtual machines together at Layer 2?",
    "description": "Virtual switch."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "BigCo has asked you as a Cloud+ consultant to connect its private cloud to a community cloud to access a human resource application. What type of cloud delivery model would you implement?",
    "description": "Hybrid."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "Carl works in accounting and wants to allocate intracompany billing for cloud services that different departments consume. What billing model is he implementing?",
    "description": "Chargeback."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "Harry is accessing a public cloud portal to add three additional webservers to the load-balanced fleet. What type of cloud service enables him to perform this operation?",
    "description": "On-demand."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "Hosted email falls under this cloud service delivery model.",
    "description": "SaaS."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "For redundancy, public clouds are segregated by these geographic divisions.",
    "description": "Regions."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "Liza works for a court recording firm that wants to store its records in the cloud with a specially developed application. A new cloud provider offers this service to all recording companies. What type of cloud model is this?",
    "description": "Community."
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "Tip of the Hat coffee company has deployed a custom cloud for their exclusive use. What type of delivery model did they deploy?",
    "description": "Private."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "Hank is a security engineer for his publicly traded company. For secure logins, he requires users to log in with something they have and something they know. What type of authentication is this?",
    "description": "Multifactor."
  },
  {
    "id": 13,
    "topic_id": 2,
    "title": "What is a type of replication that is eventually consistent?",
    "description": "Asynchronous."
  },
  {
    "id": 14,
    "topic_id": 4,
    "title": "Connie is part of the cloud migration team at an insurance company. She is investigating a Windows server in the data center that runs natively on a high-end server platform. She wants to move it to an IaaS provider. What type of migration does she need to perform?",
    "description": "P2V."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "You have been brought in to assist a company\u2019s project to move sensitive storage data to a public cloud. The company requires that the data be indecipherable if accessed by an unauthorized party. What general term is used to describe this operation?",
    "description": "Obfuscation."
  },
  {
    "id": 16,
    "topic_id": 4,
    "title": "What is the storage arrangement that divides different types of storage requirements into different offerings?",
    "description": "Tiering."
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "Jill is the storage administrator for her company\u2019s private cloud. She is deploying a new storage array that groups multiple disks into one logical drive. What storage technology is this?",
    "description": "RAID."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "Henry has created a volume on the cloud SAN. What type of storage is he implementing?",
    "description": "Block."
  },
  {
    "id": 19,
    "topic_id": 2,
    "title": "Sid is a security engineer at a large public cloud company. He is implementing a new security service that tracks activity across the network and actively shuts down malicious activity. What security application is he implementing?",
    "description": "Intrusion prevention system."
  },
  {
    "id": 20,
    "topic_id": 4,
    "title": "What is a disk array technology that can withstand the simultaneous failure of two SSD drives?",
    "description": "RAID 6."
  },
  {
    "id": 21,
    "topic_id": 4,
    "title": "What is a service delivery model where the cloud provider takes responsibility for all operating system maintenance but the customer is responsible for the applications?",
    "description": "PaaS."
  },
  {
    "id": 22,
    "topic_id": 4,
    "title": "What is the process called when a user enters their username and password to access a cloud-based server?",
    "description": "Authentication."
  },
  {
    "id": 23,
    "topic_id": 4,
    "title": "Porter is a cloud administrator who is configuring access for the storage administration team. He does not want to add rights for every user and is asking you if there is a more efficient way to administer rights for the storage group. What user administrative approach would you recommend he implement?",
    "description": "Groups."
  },
  {
    "id": 24,
    "topic_id": 4,
    "title": "Mike works for a medical records company in the United States that is planning on migrating customer records to a public cloud to accommodate growth. You have been brought on to the migration team as a Cloud+ certified consultant. What governmental requirement must Mike ensure the cloud provider meets before considering them as a potential solution?",
    "description": "HIPAA."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "What corporate process document outlines a firm\u2019s responsibility in safely deploying a fleet of database servers to the public cloud?",
    "description": "Security policy."
  },
  {
    "id": 26,
    "topic_id": 4,
    "title": "You are performing a security audit on a newly launched e-commerce site hosted on a private cloud. You are investigating the Internet-facing Windows servers and notice that many user accounts are configured to the operations staff. What would you need to do to the unused accounts to harden the servers?",
    "description": "Disable the accounts."
  },
  {
    "id": 27,
    "topic_id": 4,
    "title": "Terri is auditing the middle-tier Linux servers on her private cloud deployment and notices many services that should not be running. As a security consultant, what actions would you recommend she take?",
    "description": "Disable the services."
  },
  {
    "id": 28,
    "topic_id": 1,
    "title": "Zander is a database administrator for your private cloud operations. He is planning on attending a user conference in Austin, Texas, but wants to be able to connect to the database from his hotel in case an emergency arises. As a security consultant, which security system would you set up for his VPN?",
    "description": "IPsec."
  },
  {
    "id": 29,
    "topic_id": 4,
    "title": "BigCo has issued keyfobs that have a small display that presents a numerical code that changes every two minutes. After you enter your username and password, you are then required to enter the currently displayed number. What type of authentication is this?",
    "description": "Two-factor (or multifactor) authentication."
  },
  {
    "id": 30,
    "topic_id": 4,
    "title": "A private cloud deployment is worried about its first line of defense against attacks to its Internet-facing e-commerce webservers. Delbert is a security consultant. What solution should he implement?",
    "description": "Firewall."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "Charles wants to offer his user base a selection of two-factor authentication solutions. What two options are there?",
    "description": "Keyfob and smartphone."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "When architecting a database server migration, Herb is working to properly size the virtual servers he is implementing. What virtual pool should he focus on to make sure that there are no write latencies to the database?",
    "description": "Storage."
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "What technology enables the widespread deployment of cloud offerings?",
    "description": "Automation."
  },
  {
    "id": 34,
    "topic_id": 1,
    "title": "Beth is asking you if there is a website that shows a high-level overview of her cloud deployment. What is this called?",
    "description": "Dashboard."
  },
  {
    "id": 35,
    "topic_id": 5,
    "title": "True or false? The public cloud provider has ultimate responsibility for the integrity of your storage data.",
    "description": "False."
  },
  {
    "id": 36,
    "topic_id": 5,
    "title": "Trevor is implementing a security application that operates in each webserver that faces the Internet. He wants to track malicious attacks. What solution is he implementing?",
    "description": "Host intrusion detection system."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "What is a separate network operating in your private cloud that is accessed both internally and externally?",
    "description": "DMZ."
  },
  {
    "id": 38,
    "topic_id": 4,
    "title": "What intrusion system will monitor but not act on an Internet-based attack?",
    "description": "IDS."
  },
  {
    "id": 39,
    "topic_id": 4,
    "title": "What web security technology is implemented with HTTPS?",
    "description": "SSL/TLS."
  },
  {
    "id": 40,
    "topic_id": 4,
    "title": "What is storage that does not survive a VM restart called?",
    "description": "Ephemeral."
  },
  {
    "id": 41,
    "topic_id": 3,
    "title": "Sam wants to create a full backup on Sunday and then, during the week, back up only the files that have been modified since Sunday. As a Cloud+ consultant, you suggest what type of backup?",
    "description": "Differential."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "Hank is asking about installing vendor software on his webserver to fix a known bug in the application. What type of fix is this?",
    "description": "Patch."
  },
  {
    "id": 43,
    "topic_id": 3,
    "title": "Lori wants to back up a virtual machine image to use as a template for creating more VMs. What type of backup would you suggest that she perform?",
    "description": "Clone."
  },
  {
    "id": 44,
    "topic_id": 3,
    "title": "Randy wants to make a backup of a public cloud machine image before applying updates to the operating systems so that he can roll back if needed. What type of backup would you suggest that he implement?",
    "description": "Snapshot."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "Mindy works on her company\u2019s private cloud operations center. She knows that there are a number of virtual server upgrades taking place, and she notices on the network health status dashboards that there are a number of servers with alarms. What are two common causes for the alarms?",
    "description": "Shutdowns and restarts."
  },
  {
    "id": 46,
    "topic_id": 5,
    "title": "What is a quick release of software to fix a critical issue called?",
    "description": "Hotfix."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "Debbie has submitted a change management request to update her data analysis application. She plans on implementing an update that includes new features and a rollup of all bug fixes. What type of upgrade is Debbie requesting?",
    "description": "Version."
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "Which cloud-based system abstracts and hides much of the complexity of modern cloud systems and also reduces operational errors by executing tested cloud systems, scripts, workflows, or runbooks to make sure that the systems are configured correctly?",
    "description": "Orchestration."
  },
  {
    "id": 49,
    "topic_id": 3,
    "title": "Trevor asked you to recommend a server deployment model that features tightly coupled computers that allow for software patching without incurring downtime. What type of server deployment would you recommend?",
    "description": "Cluster."
  },
  {
    "id": 50,
    "topic_id": 3,
    "title": "Name the backup operation that is based on the change of the source data since the last backup was performed.",
    "description": "Incremental."
  },
  {
    "id": 51,
    "topic_id": 1,
    "title": "Harold is creating a disaster recovery plan based on corporate requirements that service be restored in the shortest amount of time possible if the primary cloud data center is down. What disaster recovery model would you suggest to Harold?",
    "description": "Hot site."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "Which disaster recovery measurement defines when you can expect your systems to be back online after an outage?",
    "description": "Recovery time objective."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "Which disaster recovery measurement defines the amount of lost data after a recovery?",
    "description": "Recovery point objective."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "What is long-term storage of cloud data called?",
    "description": "Archive."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "What backend cloud systems allow for on-demand provisioning of services?",
    "description": "Automation."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "What cloud service contains an ordered rule set that contains permit and deny statements and is used to protect cloud-based devices?",
    "description": "Firewall."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "Jonathan is asking you about a networking service to which he needs to make updates. This service is used to translate human-readable names to network addresses understood by computers. What service is this?",
    "description": "DNS."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "Jack is preparing to update his company\u2019s business continuity plan with details on their disaster recovery site. His plan is to have a facility ready with floor space, power, and cooling. What type of DR implementation is Jack deploying?",
    "description": "Cold site."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "BigCo has been performing an ongoing inventory of their public cloud assets and found a number of storage volumes, CPU allocations, VMs, and firewall instances that are not connected to any project and are not being used. What are these resources called?",
    "description": "Orphaned resources."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "What is a recovery model in which only minimal resources are kept online, such as critical data storage?",
    "description": "Warm site."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "The establishment of average usage over time is the data that gets collected for what type of cloud reporting?",
    "description": "Baseline."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "Lynn is documenting the maintenance responsibilities between her company and its public cloud provider. She notices that the cloud provider takes responsibility for all operating system updates and patches, and she needs to assume responsibility for the applications and services running on the operating system. Under what type of service delivery model is she operating?",
    "description": "PaaS."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "What authentication configuration will ignore a dictionary login attack after a set number of failed attempts?",
    "description": "Lockout."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "Combining several companies\u2019 user directories together for a unified cloud authentication service is called what?",
    "description": "Federations."
  },
  {
    "id": 65,
    "topic_id": 3,
    "title": "Sophia is monitoring her cloud webserver dashboard, and she notices that CPU utilization on her company\u2019s database server fleet has been consistently at more than 80 percent. She checked her baselines and noticed that 60 percent utilization is normal. What is the difference called?",
    "description": "Variance."
  },
  {
    "id": 66,
    "topic_id": 3,
    "title": "Tom\u2019s SQL database backend runs on a multi-CPU instance that often reaches 100 percent utilization. The database can operate on only a single server. What scalability model can he implement?",
    "description": "Vertical."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "Eva is the lead network architect for her company\u2019s hybrid cloud operations, and she has interconnected her private cloud to a community cloud in another province. Eva is investigating using the community cloud to supplement her private cloud operations during end-of-month processing. What operation is she going to perform?",
    "description": "Bursting."
  },
  {
    "id": 68,
    "topic_id": 3,
    "title": "During peak usage times, BigCo\u2019s fleet of Internet-facing e-commerce servers often reaches maximum CPU utilization. The managers like that the cloud is resilient enough to add and remove servers on demand. What type of scaling are they implementing?",
    "description": "Horizontal."
  },
  {
    "id": 69,
    "topic_id": 3,
    "title": "You are explaining to a new hire at your private cloud data center about the process to follow when modifying systems and services in the cloud. What is this process called?",
    "description": "Change management."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "Darian is developing a cross-cloud provider migration report as part of his company\u2019s business continuity plan. As he assesses the feasibility of migrating applications from one public cloud provider to another, what does he find is the service model that has the most lock-ins and is the most complex to migrate?",
    "description": "SaaS."
  },
  {
    "id": 71,
    "topic_id": 3,
    "title": "What type of scaling involves replacing an existing server with another that has more capabilities?",
    "description": "Vertical."
  },
  {
    "id": 72,
    "topic_id": 3,
    "title": "True or false? In a single primary database, database write performance can be improved by scaling horizontally.",
    "description": "False."
  },
  {
    "id": 73,
    "topic_id": 3,
    "title": "What cloud service provider document outlines assured system uptime and network performance guarantees?",
    "description": "Service level agreement."
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "To collect metrics, what do you set up your management application to measure?",
    "description": "Objects."
  },
  {
    "id": 75,
    "topic_id": 3,
    "title": "Name the visual representation of your current cloud operations.",
    "description": "Dashboard."
  },
  {
    "id": 76,
    "topic_id": 6,
    "title": "Rhonda is creating a change management plan to increase the processing abilities of one of her middleware application servers. What components can she upgrade to increase server processing performance?",
    "description": "CPU."
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "A set of application server instances is suffering poor performance. Brian notices that there is a lot of pagefile thrashing to the ephemeral SSD drives. You are brought in to investigate the instance configurations. What resource pool would you recommend changing to help resolve the application performance problem?",
    "description": "Memory."
  },
  {
    "id": 78,
    "topic_id": 3,
    "title": "A video hosting company has just released a popular movie for download. As soon as the announcement is made, all of the Internet-facing content servers became very slow. What resource pool increase would most likely resolve the issue?",
    "description": "Network I/O."
  },
  {
    "id": 79,
    "topic_id": 1,
    "title": "In what two formats are cloud-based reports generally presented?",
    "description": "PDF and Microsoft Excel."
  },
  {
    "id": 80,
    "topic_id": 3,
    "title": "Object tracking should be aligned with which service provider document that outlines guaranteed performance metrics?",
    "description": "Service level agreement."
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "There has been a steady increase in the response time of a cloud-hosted MySQL database application running on an IaaS deployment. A comparison of current results against baseline measurements shows that there has been a steady increase in the number of read requests over the past six months. On what resource would you focus your troubleshooting efforts?",
    "description": "Storage."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "Jeff has been monitoring resource usage increases in his webserver farm. Based on collected trending data, he will need to increase the capacity of Internet webservers as usage increases and to reduce the servers during periods of low utilization. He wants to use the automation capabilities of the public cloud to automatically use the orchestration software to add servers when there is a usage spike. What is the cloud service that automates this process?",
    "description": "Autoscaling."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "During configuration of a network interface, what is the term for the router on the connected subnet that is required to reach other subnets?",
    "description": "Default gateway."
  },
  {
    "id": 84,
    "topic_id": 6,
    "title": "What network service provides accurate time synchronization information?",
    "description": "NTP."
  },
  {
    "id": 85,
    "topic_id": 6,
    "title": "What cloud automation feature allows cloud services to expand and contract based on actual usage?",
    "description": "Elasticity."
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "Cloud capacity consumption can be measured by comparing current usage to what?",
    "description": "Baseline."
  },
  {
    "id": 87,
    "topic_id": 3,
    "title": "During a change window, the server team was applying patches to an application, and the networking team was upgrading a router\u2019s interface to 10 Gbps. When the network was down, the server team complained that they could not download the needed software patches. During a post-downtime status meeting, it was determined that which process should be modified to prevent this from happening in the future?",
    "description": "Change management."
  },
  {
    "id": 88,
    "topic_id": 1,
    "title": "Erving is asking you about cloud virtualization techniques and wants to know what a software representation of his three-tier public cloud deployment is called. What is he referring to?",
    "description": "Templates."
  },
  {
    "id": 89,
    "topic_id": 5,
    "title": "What is a software-controlled machine-to-machine interface called?",
    "description": "Application programming interface (API)."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "What determines whether servers are in the same IP subnet?",
    "description": "Subnet mask."
  },
  {
    "id": 91,
    "topic_id": 4,
    "title": "Which text-based remote access application is used to access Linux servers securely in a public cloud?",
    "description": "SSH."
  },
  {
    "id": 92,
    "topic_id": 6,
    "title": "Scott is troubleshooting a SQL access issue and wants to look at the TCP packets being sent and received from his network adapter card on the Linux database server. What command would he use to collect the traces?",
    "description": "tcpdump."
  },
  {
    "id": 93,
    "topic_id": 6,
    "title": "A remote user is unable to reach a Linux-based webserver hosted in the Singapore zone of the cloud provider. The user is located in Austin, Texas. What command can they use to verify the connection path?",
    "description": "traceroute."
  },
  {
    "id": 94,
    "topic_id": 4,
    "title": "A Cloud+ student you are mentoring asks about the mappings between Layer 2 MAC addresses and IP addresses. They want to verify that the VM has the correct network mapping information. Which utility would you tell them to use to gather this information?",
    "description": "ARP."
  },
  {
    "id": 95,
    "topic_id": 6,
    "title": "You are configuring a remote out-of-band management network that connects to router and switch serial ports in a private cloud. What product would you need to install to accomplish this task?",
    "description": "Terminal server."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "After a user authenticates to a system, what is it called when the user is given certain rights to access services?",
    "description": "Authorization."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What Windows Server application presents the server\u2019s graphical desktop on a remote user\u2019s screen?",
    "description": "Remote Desktop Services."
  },
  {
    "id": 98,
    "topic_id": 4,
    "title": "To verify network reachability from a NoSQL database server residing in a private subnet on a public cloud to the application tier, what utility can you use as a quick connectivity test?",
    "description": "ping."
  },
  {
    "id": 99,
    "topic_id": 1,
    "title": "After deploying a new public website, your validation steps ask you to check the domain name to IP address mappings. What Linux and Windows commands can be used for validation?",
    "description": "dig and nslookup."
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "Sarah made an SSH connection to a remote bastion host. She needs to add an access control list rule to allow the bastion server to access a new subnet. She needs the source IP address of her host. What command can she run on the server to collect this information?",
    "description": "ifconfig."
  },
  {
    "id": 101,
    "topic_id": 1,
    "title": "Define Infrastructure as a Service (IaaS).",
    "description": "IaaS is a cloud model that provides virtual machines, storage, and networking resources for consumers to provision and manage themselves."
  },
  {
    "id": 102,
    "topic_id": 1,
    "title": "What is Software as a Service (SaaS) and who manages the application?",
    "description": "SaaS is a cloud model where the provider manages both the application and the underlying infrastructure, delivering the software to users over the network."
  },
  {
    "id": 103,
    "topic_id": 1,
    "title": "When should an organization choose a Platform as a Service (PaaS) model over IaaS?",
    "description": "Choose PaaS when you want to offload management of the underlying virtual machines and focus on developing and deploying applications, reducing operational overhead."
  },
  {
    "id": 104,
    "topic_id": 1,
    "title": "What is the difference between a public cloud and a private cloud?",
    "description": "A public cloud is owned and operated by a third\u2011party provider offering services to multiple customers, while a private cloud is dedicated to a single organization, often on\u2011premises or hosted for exclusive use."
  },
  {
    "id": 105,
    "topic_id": 1,
    "title": "In a scenario where two redundant SQL servers must never share the same hardware, what cloud feature replicates this requirement?",
    "description": "Cloud providers offer hypervisor affinity (or VM\u2011host affinity) rules that ensure redundant VMs are placed on separate physical hosts for resiliency."
  },
  {
    "id": 106,
    "topic_id": 1,
    "title": "How does serverless (FaaS) compute differ from traditional IaaS compute?",
    "description": "Serverless/FaaS lets you upload application code and the provider runs it on managed infrastructure without provisioning VMs, whereas IaaS requires you to create and manage virtual machines yourself."
  },
  {
    "id": 107,
    "topic_id": 1,
    "title": "What is a Virtual Private Cloud (VPC) and what purpose does it serve?",
    "description": "A VPC is an isolated virtual network within a public cloud that allows you to define IP ranges, subnets, and routing, providing a closed environment for resources."
  },
  {
    "id": 108,
    "topic_id": 1,
    "title": "Compare object storage and block storage in terms of typical use cases.",
    "description": "Object storage is optimized for massive, durable, and inexpensive data like backups or media files, while block storage provides low\u2011latency, high\u2011performance storage for workloads such as databases or virtual machine disks."
  },
  {
    "id": 109,
    "topic_id": 1,
    "title": "If an organization wants to restrict cloud resource access to only users inside its corporate office, what must be done?",
    "description": "By default cloud resources are blocked; you must explicitly allow access from the corporate network, typically via firewall rules, security groups, or VPN connections."
  },
  {
    "id": 110,
    "topic_id": 1,
    "title": "What is the Internet of Things (IoT) and how does the cloud enable it?",
    "description": "IoT refers to small, purpose\u2011built devices that collect data and send it to a central location for processing; the cloud provides ubiquitous access and elastic resources to ingest, store, and analyze that data."
  },
  {
    "id": 111,
    "topic_id": 1,
    "title": "Define supervised learning and give an example of its use.",
    "description": "Supervised learning trains an ML/AI model with labeled sample data to make predictions or recognize patterns, such as voice recognition trained with voice samples."
  },
  {
    "id": 112,
    "topic_id": 1,
    "title": "What is unsupervised learning and how does it differ from supervised learning?",
    "description": "Unsupervised learning automatically finds patterns and creates clusters without manual training, whereas supervised learning requires labeled data to teach the model what to recognize."
  },
  {
    "id": 113,
    "topic_id": 1,
    "title": "A company plans to move a low\u2011risk web application to the cloud as a proof\u2011of\u2011concept. Which cloud service model would likely provide the quickest migration with minimal management overhead?",
    "description": "Using a SaaS model (or a managed PaaS service) would allow the quickest migration because the provider handles both the application and underlying infrastructure."
  },
  {
    "id": 114,
    "topic_id": 1,
    "title": "Explain the difference between capital expenditures (CapEx) and operational expenditures (OpEx) in the context of cloud adoption.",
    "description": "CapEx refers to large upfront costs for purchasing physical infrastructure, while OpEx is an ongoing expense based on usage, such as monthly fees for cloud services."
  },
  {
    "id": 115,
    "topic_id": 1,
    "title": "Define a compute pool in cloud architecture.",
    "description": "A compute pool is a collection of virtualized compute resources\u2014CPU, memory, and storage\u2014that the cloud provider manages for high availability and redundancy."
  },
  {
    "id": 116,
    "topic_id": 1,
    "title": "What is the difference between synchronous and asynchronous data replication?",
    "description": "Synchronous replication copies data in real time to a remote location, providing minimal data loss and short recovery time, while asynchronous replication copies data after a delay or on a schedule, often reducing transfer costs but allowing some data loss."
  },
  {
    "id": 117,
    "topic_id": 1,
    "title": "When would you choose a VPN connection over a dedicated private line to access cloud resources?",
    "description": "A VPN is appropriate when secure, encrypted connectivity is needed over the Internet for applications that do not require constant, predictable latency or dedicated bandwidth, such as linking office networks to cloud resources."
  },
  {
    "id": 118,
    "topic_id": 1,
    "title": "How does autoscaling improve cost efficiency for a web application that experiences occasional traffic spikes?",
    "description": "Autoscaling automatically adds web servers during high demand and terminates them when load returns to normal, ensuring the organization only pays for the capacity it actually uses."
  },
  {
    "id": 119,
    "topic_id": 1,
    "title": "In a scenario where a web application must remain available despite a server failure, which cloud design elements should you implement?",
    "description": "Deploy the application across multiple availability zones or regions, use load balancing to distribute traffic, and enable autoscaling with health checks to replace failed instances automatically."
  },
  {
    "id": 120,
    "topic_id": 1,
    "title": "What is CPU pinning and when might it be used?",
    "description": "CPU pinning assigns a virtual CPU to a specific physical CPU core, used when an application requires consistent, low\u2011latency processing such as high\u2011performance computing workloads."
  },
  {
    "id": 121,
    "topic_id": 1,
    "title": "Compare the typical uses of elastic block storage (EBS) and object storage in cloud environments.",
    "description": "Elastic block storage provides block\u2011level storage for VMs and databases requiring low\u2011latency I/O, while object storage holds unstructured data like files and backups, accessed via APIs and optimized for durability rather than performance."
  },
  {
    "id": 122,
    "topic_id": 1,
    "title": "What role does a load balancer play in a loosely coupled, multi\u2011tier application?",
    "description": "The load balancer receives client connections and distributes them across multiple web servers, providing redundancy, scaling, and additional functions such as TLS termination and health checks."
  },
  {
    "id": 123,
    "topic_id": 1,
    "title": "How would you test whether a newly deployed VM image contains any known security weaknesses?",
    "description": "Run a vulnerability scan against the VM; the scanner uses a database of known exploits to identify potential security holes that need remediation."
  },
  {
    "id": 124,
    "topic_id": 1,
    "title": "Why might an organization choose asynchronous replication for database read replicas instead of synchronous replication?",
    "description": "Asynchronous replication reduces data transfer costs and allows the primary database to handle critical workloads while reports run on the read replica, accepting some latency in data freshness."
  },
  {
    "id": 125,
    "topic_id": 1,
    "title": "Define the four primary cloud environments and their typical purpose.",
    "description": "Development is for creating new applications; Staging (pre\u2011production) is for building systems before release; Production (or live) runs the operational workload; Testing/QA validates changes before they reach production."
  },
  {
    "id": 126,
    "topic_id": 1,
    "title": "When performing a penetration test on a cloud deployment, what provider requirement must you typically satisfy?",
    "description": "Cloud providers usually require advance permission and coordination before any penetration testing is conducted."
  },
  {
    "id": 127,
    "topic_id": 1,
    "title": "What is the impact of enabling CPU overcommitment on a VM host?",
    "description": "CPU overcommitment allows more virtual CPUs than physical cores, which can increase utilization but may cause performance degradation if the host becomes CPU\u2011bound."
  },
  {
    "id": 128,
    "topic_id": 1,
    "title": "In a scenario where an application must never be exposed to the public Internet, which connectivity option should be selected?",
    "description": "Use a VPN or a dedicated private connection to link the on\u2011premises network to the cloud, keeping the application inaccessible via public IP addresses."
  },
  {
    "id": 129,
    "topic_id": 1,
    "title": "What monitoring metric would you track to detect a storage performance bottleneck?",
    "description": "Track I/O operations per second (IOPS) for the storage volume; a drop below expected thresholds indicates a performance bottleneck."
  },
  {
    "id": 130,
    "topic_id": 1,
    "title": "What is elasticity in cloud computing?",
    "description": "Elasticity is the cloud\u2019s ability to scale resources up or down rapidly to match changing demand."
  },
  {
    "id": 131,
    "topic_id": 1,
    "title": "Define autoscaling and indicate which cloud service model provides it automatically.",
    "description": "Autoscaling automatically adds or removes compute resources based on workload thresholds, and it is provided automatically for IaaS services."
  },
  {
    "id": 132,
    "topic_id": 1,
    "title": "What is the difference between on\u2011demand cloud services and Pay\u2011as\u2011You\u2011Go (PAYG) pricing?",
    "description": "On\u2011demand refers to the ability to provision and de\u2011provision resources instantly as needed, while PAYG describes the billing model where you are charged only for the resources you actually consume."
  },
  {
    "id": 133,
    "topic_id": 1,
    "title": "Why should a proof\u2011of\u2011concept design be staged in the cloud before a full migration?",
    "description": "Staging a proof\u2011of\u2011concept lets teams test the application, configuration, networking, storage, and security in the cloud environment, confirming the design works before going live."
  },
  {
    "id": 134,
    "topic_id": 1,
    "title": "Your application must stay highly available in a region prone to earthquakes. Which deployment construct should you use and how?",
    "description": "Deploy redundant VMs across multiple Availability Zones within the region, ensuring each AZ is in a separate data center with independent power and network connections."
  },
  {
    "id": 135,
    "topic_id": 1,
    "title": "What is a cloud region and how does it differ from an availability zone?",
    "description": "A region is a geographic area (often a country or state) that contains multiple isolated data centers, whereas an availability zone is an individual data center within a region with its own redundant power and network."
  },
  {
    "id": 136,
    "topic_id": 1,
    "title": "How can baseline metrics be used to reduce false alerts for a database server that briefly spikes to 90\u202f% CPU usage?",
    "description": "Create separate short\u2011term (e.g., 15\u2011minute) and long\u2011term (daily) baselines; configure alerts to trigger only when the average utilization exceeds a set threshold (e.g., 80\u202f%) rather than on brief spikes."
  },
  {
    "id": 137,
    "topic_id": 1,
    "title": "In the shared responsibility model, what responsibilities shift from the provider to the customer when moving from IaaS to PaaS?",
    "description": "With IaaS the customer manages the operating system and applications; with PaaS the provider also manages the OS and underlying VMs, leaving the customer responsible only for the applications and data."
  },
  {
    "id": 138,
    "topic_id": 1,
    "title": "You need low\u2011latency communication between two VMs that must run on the same physical host. Which placement strategy should you use?",
    "description": "Create a cluster placement (affinity) rule that forces the VMs to be placed on the same host, optionally within the same cluster."
  },
  {
    "id": 139,
    "topic_id": 1,
    "title": "Which protocols are used for remote management of Windows and Linux VMs, and what ports do they use?",
    "description": "Windows VMs use Remote Desktop Protocol (RDP) on TCP port\u202f3389; Linux (and optionally Windows) VMs use Secure Shell (SSH) on TCP port\u202f22."
  },
  {
    "id": 140,
    "topic_id": 1,
    "title": "What Service model gives the cloud provider ownership and management of the entire computing environment, including hardware, operating system, and applications?",
    "description": "Software as a Service (SaaS) provides full control of hardware, OS, and applications by the provider."
  },
  {
    "id": 141,
    "topic_id": 1,
    "title": "Define Infrastructure as a Service (IaaS) in terms of provider responsibilities.",
    "description": "IaaS is the model where the provider owns and manages only the physical computing hardware, while the customer manages the operating system, middleware, and applications."
  },
  {
    "id": 142,
    "topic_id": 1,
    "title": "What Service model includes provider\u2011managed hardware and operating system but leaves application software under customer control?",
    "description": "Platform as a Service (PaaS) provides managed hardware and OS, while the customer builds and runs their own applications."
  },
  {
    "id": 143,
    "topic_id": 1,
    "title": "Define cloud mobility.",
    "description": "Cloud mobility is the ability to access cloud resources from any location using devices such as laptops, tablets, smartphones, or thin/thick clients."
  },
  {
    "id": 144,
    "topic_id": 1,
    "title": "What does virtualization enable in a cloud environment?",
    "description": "Virtualization creates software representations of physical resources (CPU, RAM, storage, networking) to allow scalable, multi\u2011tenant cloud offerings."
  },
  {
    "id": 145,
    "topic_id": 1,
    "title": "Which technology provides private, low\u2011latency network interconnectivity between an on\u2011premises data center and cloud resources?",
    "description": "Direct Connect (or a similar dedicated connectivity service) provides private, low\u2011latency links between corporate data centers and the cloud."
  },
  {
    "id": 146,
    "topic_id": 1,
    "title": "Explain replication in the context of cloud data management.",
    "description": "Replication is the transfer and synchronization of data between computing or storage resources to maintain consistency and availability."
  },
  {
    "id": 147,
    "topic_id": 1,
    "title": "What cloud feature distributes workload across multiple servers when a single server can no longer handle demand?",
    "description": "Load balancing spreads traffic and processing across multiple cloud resources to handle increased workloads."
  },
  {
    "id": 148,
    "topic_id": 1,
    "title": "Name two common remote\u2011access protocols used to manage cloud servers.",
    "description": "Remote Desktop Protocol (RDP) and Secure Shell (SSH) are the two common protocols."
  },
  {
    "id": 149,
    "topic_id": 1,
    "title": "Why is establishing capacity planning important before deploying cloud resources?",
    "description": "Capacity planning helps determine the appropriate size and quantity of cloud resources needed to meet performance and cost goals."
  },
  {
    "id": 150,
    "topic_id": 1,
    "title": "Compare IaaS and PaaS: what is the primary difference in terms of customer responsibilities?",
    "description": "With IaaS, the customer manages the operating system and applications; with PaaS, the provider also manages the operating system, leaving the customer to focus only on applications."
  },
  {
    "id": 151,
    "topic_id": 1,
    "title": "Scenario: A development team wants to create custom web applications but does not want to maintain the underlying OS. Which service model should they choose and why?",
    "description": "They should choose Platform as a Service (PaaS) because it supplies managed hardware and OS while allowing them to develop and run their own applications."
  },
  {
    "id": 152,
    "topic_id": 1,
    "title": "Scenario: An e\u2011commerce site experiences unpredictable traffic spikes. Which cloud capability should be implemented to maintain performance and why?",
    "description": "Load balancing should be implemented to distribute traffic across multiple servers, ensuring the site remains responsive during spikes."
  },
  {
    "id": 215,
    "topic_id": 1,
    "title": "Define FIPS 140-2.",
    "description": "FIPS 140-2 is a U.S. government standard that defines security requirements for cryptographic modules."
  },
  {
    "id": 216,
    "topic_id": 1,
    "title": "What is the difference between IPsec and SSL/TLS?",
    "description": "IPsec secures network\u2011layer (IP) traffic and is used for site\u2011to\u2011site or remote\u2011access VPNs, while SSL/TLS secures application\u2011layer traffic such as HTTPS for web communications."
  },
  {
    "id": 217,
    "topic_id": 1,
    "title": "When should a web application firewall (WAF) be used?",
    "description": "A WAF should be used to protect Internet\u2011facing web services from application\u2011specific attacks such as HTTP flood attacks."
  },
  {
    "id": 218,
    "topic_id": 1,
    "title": "In an IaaS cloud deployment, you need to retain Apache logs from a VM centrally. What should you configure?",
    "description": "Configure the VM to export or stream its application logs to the cloud provider\u2019s logging service."
  },
  {
    "id": 219,
    "topic_id": 1,
    "title": "Define a host\u2011based firewall.",
    "description": "A host\u2011based firewall is software on an individual system that filters traffic by IP address, port, and protocol to protect the host from internal and external threats."
  },
  {
    "id": 220,
    "topic_id": 1,
    "title": "What is the difference between L2TP and PPTP?",
    "description": "L2TP transports layer\u20112 frames over IP and is often paired with IPsec for encryption, whereas PPTP is deprecated, encapsulates PPP frames in GRE, and provides no native encryption."
  },
  {
    "id": 221,
    "topic_id": 1,
    "title": "In this situation, an employee has left the company. What immediate action should be taken regarding their account?",
    "description": "Disable the user\u2019s account as part of the off\u2011boarding process to prevent unauthorized access."
  },
  {
    "id": 222,
    "topic_id": 1,
    "title": "How would you mitigate a distributed denial\u2011of\u2011service (DDoS) attack targeting a public web server?",
    "description": "Use the cloud provider\u2019s DDoS protection services and place a web application firewall (WAF) in front of the server to filter malicious traffic."
  },
  {
    "id": 223,
    "topic_id": 1,
    "title": "Define a reverse proxy and its primary security benefit.",
    "description": "A reverse proxy sits at the network edge, intercepts incoming HTTP(S) requests, forwards them to backend servers, and can block layer\u20117 attacks while providing load balancing."
  },
  {
    "id": 224,
    "topic_id": 1,
    "title": "A multi\u2011tenant SaaS application must meet PCI\u2011DSS compliance. Which security controls are mandatory?",
    "description": "Implement strong encryption for data in transit and at rest, enforce two\u2011factor authentication, maintain detailed logging, and perform regular vulnerability scanning and patching."
  },
  {
    "id": 225,
    "topic_id": 1,
    "title": "What is the purpose of disabling unused services on a server?",
    "description": "Disabling unused services reduces the attack surface area, preventing potential exploitation from unnecessary open ports or vulnerable applications."
  },
  {
    "id": 226,
    "topic_id": 1,
    "title": "When should you rename or disable default accounts on networking appliances?",
    "description": "If the default accounts are required for operation, rename them and change passwords; otherwise, disable them to eliminate a known security hole."
  },
  {
    "id": 227,
    "topic_id": 1,
    "title": "How does a file integrity monitoring (FIM) system detect unauthorized changes?",
    "description": "FIM calculates a cryptographic hash of a file and compares it to a stored baseline; a mismatch indicates the file has been altered."
  },
  {
    "id": 228,
    "topic_id": 1,
    "title": "What is the role of a certificate authority (CA) in a PKI framework?",
    "description": "A CA issues digital certificates, signs them with its private key to create a digital signature, and thereby validates the identity of the certificate holder."
  },
  {
    "id": 229,
    "topic_id": 1,
    "title": "What is authentication in a cloud environment?",
    "description": "Authentication is the process of verifying an identity\u2019s credentials\u2014such as a username and password, security token, or API key\u2014before allowing any access to cloud resources."
  },
  {
    "id": 230,
    "topic_id": 1,
    "title": "Define authorization as it applies to cloud objects.",
    "description": "Authorization determines which actions an authenticated identity may perform on specific cloud objects, and can include granular rules based on time, IP address, or other conditions."
  },
  {
    "id": 231,
    "topic_id": 1,
    "title": "What is the difference between a whitelist and a blacklist in network\u2011based access control?",
    "description": "A whitelist denies all traffic by default and permits only explicitly allowed ports, protocols, or IPs, while a blacklist permits all traffic by default and blocks only the explicitly denied items."
  },
  {
    "id": 232,
    "topic_id": 1,
    "title": "When should you assign permissions to a user group rather than directly to individual user accounts?",
    "description": "Use groups when many users share the same role or job function, because groups simplify management and ensure consistent permission sets across those users."
  },
  {
    "id": 233,
    "topic_id": 1,
    "title": "A cloud admin wants to allow access to a storage bucket only from corporate IP range 203.0.113.0/24 during business hours (8\u202fam\u20116\u202fpm). Which access\u2011control feature enables this granularity?",
    "description": "Granular authorization rules that can specify allowed IP addresses and time windows provide that level of control."
  },
  {
    "id": 234,
    "topic_id": 1,
    "title": "What is Role\u2011Based Access Control (RBAC) and how does it assign permissions?",
    "description": "RBAC grants access rights based on predefined roles; users are assigned to roles and inherit the permissions attached to those roles."
  },
  {
    "id": 235,
    "topic_id": 1,
    "title": "Contrast Mandatory Access Control (MAC) with Discretionary Access Control (DAC).",
    "description": "MAC enforces centrally defined security policies that users cannot change, often using classification labels, whereas DAC lets object owners grant or revoke rights to other users at their discretion."
  },
  {
    "id": 236,
    "topic_id": 1,
    "title": "In a public\u2011cloud IaaS deployment, who is responsible for securing the virtual machine\u2019s operating system?",
    "description": "The customer is responsible for securing the VM and its operating system; the provider secures the underlying infrastructure up to the hypervisor."
  },
  {
    "id": 237,
    "topic_id": 1,
    "title": "Your organization uses a cloud service that lets users log in once on their workstation and then access multiple SaaS applications without re\u2011authenticating. Which access\u2011control technique is being used?",
    "description": "Single Sign\u2011On (SSO) provides that capability."
  },
  {
    "id": 238,
    "topic_id": 1,
    "title": "What is multifactor authentication (MFA) and why is it more secure than single\u2011factor authentication?",
    "description": "MFA requires two or more independent credentials (e.g., password plus token or biometric), reducing the risk of compromise compared to relying on a single password."
  },
  {
    "id": 239,
    "topic_id": 1,
    "title": "You need to block all inbound traffic except SSH (port\u202f22) from a specific admin subnet. Which network\u2011based access control approach should you implement?",
    "description": "Implement a whitelist ACL that denies all traffic by default and explicitly permits SSH from the admin subnet."
  },
  {
    "id": 240,
    "topic_id": 1,
    "title": "In a hybrid cloud that combines private and public environments, who determines the security responsibilities for resources that move between the two clouds?",
    "description": "Security responsibilities are defined jointly by the private organization\u2019s policies and the public provider\u2019s agreement, based on the chosen service and deployment models."
  },
  {
    "id": 241,
    "topic_id": 1,
    "title": "Multifactor authentication must include something you know and something you have. What are these two factors?",
    "description": "The two factors are a knowledge factor (something you know, like a password or PIN) and a possession factor (something you have, such as a token or smart\u2011card)."
  },
  {
    "id": 242,
    "topic_id": 1,
    "title": "What is the document called that defines a company\u2019s cloud controls, organizational policies, responsibilities, and underlying technologies?",
    "description": "It is called a cloud security policy."
  },
  {
    "id": 243,
    "topic_id": 1,
    "title": "Which type of access control gives users the ability to grant or assign rights to objects themselves?",
    "description": "Discretionary Access Control (DAC)."
  },
  {
    "id": 244,
    "topic_id": 1,
    "title": "What approach reduces the need to sign into multiple systems for access?",
    "description": "Single Sign\u2011On (SSO)."
  },
  {
    "id": 245,
    "topic_id": 1,
    "title": "Define encryption as used in cloud security.",
    "description": "Encryption is any method of encoding data so that its readability and meaning are concealed from unauthorized parties."
  },
  {
    "id": 246,
    "topic_id": 1,
    "title": "Which technology allows software\u2011scripted responses to security events and can stop an attempted breach in progress?",
    "description": "Security Orchestration, Automation, and Response (SOAR)."
  },
  {
    "id": 247,
    "topic_id": 1,
    "title": "In cloud terminology, what term describes a file, virtual machine, load balancer, or any other item that can be accessed and manipulated?",
    "description": "A cloud resource."
  },
  {
    "id": 248,
    "topic_id": 1,
    "title": "What security model do public clouds implement that defines how responsibilities are divided between provider and customer?",
    "description": "The shared\u2011responsibility security model."
  },
  {
    "id": 249,
    "topic_id": 1,
    "title": "What is the standardized set of roles, policies, and procedures used to manage digital certificates and public\u2011private key encryption?",
    "description": "Public Key Infrastructure (PKI)."
  },
  {
    "id": 250,
    "topic_id": 1,
    "title": "In which service model does the cloud provider assume security responsibility up to and including the application level?",
    "description": "Software as a Service (SaaS)."
  },
  {
    "id": 251,
    "topic_id": 1,
    "title": "How does discretionary access control differ from a centrally controlled access method?",
    "description": "Discretionary access control allows individual users to grant or assign rights to objects themselves, whereas a centrally controlled method requires an administrator or central authority to assign all permissions."
  },
  {
    "id": 285,
    "topic_id": 1,
    "title": "What is a hypervisor?",
    "description": "A hypervisor is the software layer that creates and manages virtual machines (VMs) on a physical host."
  },
  {
    "id": 286,
    "topic_id": 1,
    "title": "What is the difference between provider\u2011managed hypervisor patching and customer\u2011managed hypervisor patching?",
    "description": "With provider\u2011managed patching, the cloud provider applies hypervisor updates; with customer\u2011managed patching, the customer is responsible for updating the hypervisor, typically on bare\u2011metal servers they control."
  },
  {
    "id": 287,
    "topic_id": 1,
    "title": "How would you patch a virtual machine with minimal downtime using a load balancer?",
    "description": "Remove the VM from the load balancer target group, apply the patches, then add the VM back; repeat the process for each VM in a rolling fashion."
  },
  {
    "id": 288,
    "topic_id": 1,
    "title": "In a blue\u2011green deployment, you have patched the green environment but discover an issue after switching traffic. What is the rollback step?",
    "description": "Redirect traffic back to the unchanged blue environment, making it active again while the green environment remains offline for remediation."
  },
  {
    "id": 289,
    "topic_id": 1,
    "title": "Define a virtual appliance.",
    "description": "A virtual appliance is a specialized, often Linux\u2011based, application or suite (e.g., firewall, load balancer, IDS/IPS) that runs inside a virtual machine."
  },
  {
    "id": 290,
    "topic_id": 1,
    "title": "What is the difference between rolling updates and canary deployments?",
    "description": "Rolling updates sequentially patch every system in the fleet, while canary deployments apply the update to a small subset first to validate before wider rollout."
  },
  {
    "id": 291,
    "topic_id": 1,
    "title": "When should you schedule patching of storage systems, and who is typically responsible for the updates?",
    "description": "Patch storage systems during a predefined maintenance window, and the cloud provider is usually responsible for applying those updates."
  },
  {
    "id": 292,
    "topic_id": 1,
    "title": "A cluster node requires a reboot after a critical patch. How can you apply the patch without affecting service availability?",
    "description": "Take the node offline one at a time while other nodes continue handling the workload, apply the patch and reboot, then bring the node back online before moving to the next node."
  },
  {
    "id": 293,
    "topic_id": 1,
    "title": "What is a maintenance window in the context of patch management?",
    "description": "A maintenance window is a scheduled time period allocated for applying patches and related tasks to minimize impact on users and services."
  },
  {
    "id": 294,
    "topic_id": 1,
    "title": "How can automation tools like Puppet, Chef, or Ansible help with production patch rollouts?",
    "description": "They can consistently deploy patches across many systems, enforce version compliance, and integrate testing and rollback steps to reduce human error."
  },
  {
    "id": 295,
    "topic_id": 1,
    "title": "Define a hotfix in the context of software updates.",
    "description": "A hotfix is a quickly developed software update that addresses a specific problem, often customer\u2011specific, and is deployed with minimal testing."
  },
  {
    "id": 296,
    "topic_id": 1,
    "title": "What is the difference between a hotfix and a patch?",
    "description": "A hotfix is an urgent, narrowly scoped fix released rapidly with limited testing, while a patch is a more thoroughly tested update that fixes bugs, security issues, or performance problems and is not typically feature\u2011enhancing."
  },
  {
    "id": 297,
    "topic_id": 1,
    "title": "When a critical security vulnerability is discovered and must be remedied immediately, which type of update should be applied and why?",
    "description": "A hotfix should be applied because it provides a rapid fix for the specific issue, allowing the vulnerability to be closed quickly despite the higher risk of limited testing."
  },
  {
    "id": 298,
    "topic_id": 1,
    "title": "Define a version update and explain what an \u201cn\u20111\u201d policy means.",
    "description": "A version update replaces a product with a newer release that may add features and roll up prior patches; an \u201cn\u20111\u201d policy means the organization runs one version behind the latest to avoid potential issues with brand\u2011new releases."
  },
  {
    "id": 299,
    "topic_id": 1,
    "title": "Compare stable, Long\u2011Term Support (LTS), and beta releases.",
    "description": "Stable releases are thoroughly tested, widely supported, and intended for production; LTS releases follow a scheduled cadence with a defined support lifetime, prioritizing reliability over new features; beta releases provide early access to new features but are expected to be buggy and unsuitable for production."
  },
  {
    "id": 300,
    "topic_id": 1,
    "title": "When should a rollback be performed after an update?",
    "description": "A rollback should be performed when the update fails, does not resolve the issue, or introduces new problems, returning the software to its prior stable state."
  },
  {
    "id": 301,
    "topic_id": 1,
    "title": "If you want to evaluate a new feature without affecting production workloads, which version type is most appropriate?",
    "description": "A beta version is most appropriate because it provides access to new features for testing while keeping production environments on stable or LTS releases."
  },
  {
    "id": 302,
    "topic_id": 1,
    "title": "Define workflow automation.",
    "description": "Workflow automation is the automated tracking and execution of a defined sequence of actions, ensuring each step completes successfully before the next begins, thereby reducing errors and providing consistency."
  },
  {
    "id": 303,
    "topic_id": 1,
    "title": "How does a runbook differ from an orchestration system?",
    "description": "A runbook defines the specific tasks or scripts to be executed for a particular operation, while an orchestration system coordinates multiple runbooks and workflows, handling ordering, dependencies, and overall automation."
  },
  {
    "id": 304,
    "topic_id": 1,
    "title": "You need to patch hundreds of VMs with minimal human intervention and ensure rollbacks are possible. Which automation approach should you use?",
    "description": "Use a third\u2011party patching automation tool (or scheduled custom scripts) that can push updates, validate success, and perform rollbacks automatically across the VM fleet."
  },
  {
    "id": 305,
    "topic_id": 1,
    "title": "Define the difference between a snapshot and a clone of a virtual machine.",
    "description": "A snapshot captures a point\u2011in\u2011time image of a VM\u2019s state and configuration, allowing quick revert, whereas a clone creates a full copy of the VM to be used as a new, independent instance."
  },
  {
    "id": 306,
    "topic_id": 1,
    "title": "Before applying a critical patch to a production VM, what precaution should you take to enable a fast revert if needed?",
    "description": "Create a crash\u2011consistent snapshot of the running VM (or an application\u2011consistent snapshot if the VM is shut down) so you can revert to that state if the patch causes issues."
  },
  {
    "id": 307,
    "topic_id": 1,
    "title": "Define Recovery Time Objective (RTO) and Recovery Point Objective (RPO).",
    "description": "RTO is the maximum time allowed to restore data and resume operations after a failure, while RPO is the maximum amount of data loss measured in time that an organization can tolerate."
  },
  {
    "id": 308,
    "topic_id": 1,
    "title": "What is the difference between a full backup and a storage clone?",
    "description": "A full backup copies data at the file level, often compressing and encrypting it, whereas a clone creates an exact block\u2011level copy of the source volume, using the same amount of storage as the original."
  },
  {
    "id": 309,
    "topic_id": 1,
    "title": "When would you choose an image backup over a file backup?",
    "description": "Use an image backup when you need a byte\u2011by\u2011byte copy of an entire volume for disaster recovery, VM roll\u2011backs, or rapid workstation provisioning; use a file backup for smaller, more selective restores and lower storage consumption."
  },
  {
    "id": 310,
    "topic_id": 1,
    "title": "A business requires an RPO of 5 minutes. Which backup method best satisfies this requirement?",
    "description": "Frequent transaction\u2011log backups combined with near\u2011real\u2011time snapshots (e.g., copy\u2011on\u2011write or redirect\u2011on\u2011write) provide the granularity needed to meet a 5\u2011minute RPO."
  },
  {
    "id": 311,
    "topic_id": 1,
    "title": "Compare copy\u2011on\u2011write and redirect\u2011on\u2011write snapshots.",
    "description": "Copy\u2011on\u2011write snapshots keep the original data unchanged and store only changes in reserved space, causing write\u2011performance overhead; redirect\u2011on\u2011write snapshots create pointers to original blocks and write new data elsewhere, reducing I/O overhead and offering faster performance."
  },
  {
    "id": 312,
    "topic_id": 1,
    "title": "How can you implement the 3\u20112\u20111 backup rule using cloud services?",
    "description": "Store three copies of data: the primary live dataset, a second copy on a different cloud storage tier (e.g., block storage), and a third copy in a separate geographic region or offline vault such as a virtual tape library."
  },
  {
    "id": 313,
    "topic_id": 1,
    "title": "A virtual machine must be restored within 30 minutes after a failure. Which backup type and target provide the fastest recovery?",
    "description": "An image backup stored as a snapshot on a high\u2011performance block storage volume in the same region enables rapid VM restoration within the 30\u2011minute window."
  },
  {
    "id": 314,
    "topic_id": 1,
    "title": "Define a synthetic full backup.",
    "description": "A synthetic full backup is an updated full backup created offline by merging an existing full backup with subsequent incremental backups, eliminating the need to run a new full backup operation."
  },
  {
    "id": 315,
    "topic_id": 1,
    "title": "What is the primary advantage of remote backups compared to local backups?",
    "description": "Remote backups are stored at a geographically separate location, protecting data from site\u2011wide disasters such as fire or flood, whereas local backups share the same risk as the primary data."
  },
  {
    "id": 316,
    "topic_id": 1,
    "title": "An organization uses nightly incremental backups and a weekly full backup. How does this backup scheme affect the recovery time objective (RTO) when restoring data from three days ago?",
    "description": "Restoring requires first applying the most recent full backup, then sequentially applying each incremental backup up to the desired point, which lengthens the RTO compared to a differential or synthetic full approach because multiple incremental sets must be processed."
  },
  {
    "id": 317,
    "topic_id": 1,
    "title": "What is the Blue/Green deployment model?",
    "description": "It is a software deployment methodology that uses two identical production configurations\u2014one active (Blue) and one standby (Green)\u2014allowing traffic to be switched between them for safe releases."
  },
  {
    "id": 318,
    "topic_id": 1,
    "title": "Define continuous delivery in the context of software updates.",
    "description": "Continuous delivery is the constant delivery of software updates or patches to operating systems or applications as they become available."
  },
  {
    "id": 319,
    "topic_id": 1,
    "title": "If a newly deployed patch causes undesirable results on a fleet of VMs, what corrective action should be taken?",
    "description": "Perform a rollback to withdraw the problematic patch from operations."
  },
  {
    "id": 320,
    "topic_id": 1,
    "title": "What is the difference between a snapshot and a clone of a virtual machine?",
    "description": "A snapshot captures the state of a VM at a point in time for restoration, while cloning creates a new, separate VM based on the original."
  },
  {
    "id": 321,
    "topic_id": 1,
    "title": "What term describes the endpoint or storage system where backup data is stored?",
    "description": "Target backup repository."
  },
  {
    "id": 322,
    "topic_id": 1,
    "title": "What are backup copies of data that can be stored locally or remotely called?",
    "description": "Backup copies."
  },
  {
    "id": 323,
    "topic_id": 1,
    "title": "What is a hotfix?",
    "description": "A hotfix is a software update released quickly to fix an immediate and specific problem."
  },
  {
    "id": 324,
    "topic_id": 1,
    "title": "Explain what an incremental backup is and how it differs from a full backup.",
    "description": "An incremental backup uses the latest full backup as a base and then backs up only the data that has changed since the previous backup, resulting in smaller, faster backup operations."
  },
  {
    "id": 325,
    "topic_id": 1,
    "title": "When performing maintenance that will make a server unresponsive, what should be disabled to avoid interference?",
    "description": "Services should be disabled during maintenance."
  },
  {
    "id": 326,
    "topic_id": 1,
    "title": "What is a backup window?",
    "description": "A backup window is the time period allocated for a backup operation to run while the target storage system is offline or lightly used."
  },
  {
    "id": 327,
    "topic_id": 1,
    "title": "Define Recovery Point Objective (RPO) in the context of disaster recovery.",
    "description": "RPO is the maximum age of files that must be recovered after a disaster; it indicates how much data loss is acceptable, expressed as the point in time to which data must be restored."
  },
  {
    "id": 328,
    "topic_id": 1,
    "title": "What does Recovery Time Objective (RTO) measure?",
    "description": "RTO is the target duration of time within which a business process must be restored after a disruption to avoid unacceptable consequences."
  },
  {
    "id": 329,
    "topic_id": 1,
    "title": "Compare a hot site and a warm site DR model in terms of cost and recovery speed.",
    "description": "A hot site runs fully active and synchronized with the primary site, offering the shortest RTO but at the highest cost; a warm site keeps only critical data active, resulting in a longer RTO and lower cost."
  },
  {
    "id": 330,
    "topic_id": 1,
    "title": "During a holiday shopping season, an e\u2011commerce site cannot tolerate more than a few minutes of downtime. Which DR model should be chosen and why?",
    "description": "A hot site should be selected because it provides real\u2011time data replication and immediate failover, meeting the very short RTO required for high\u2011traffic sales periods."
  },
  {
    "id": 331,
    "topic_id": 1,
    "title": "When would you choose synchronous replication over asynchronous replication for a mission\u2011critical database?",
    "description": "Synchronous replication is chosen when the RPO must be near zero and the RTO must be short, ensuring that data is written to the replica in real time, which is essential for mission\u2011critical workloads."
  },
  {
    "id": 332,
    "topic_id": 1,
    "title": "What key factors must be considered for disaster recovery network capacity?",
    "description": "You must ensure sufficient WAN bandwidth for peak traffic, additional bandwidth for replication and backup, and that critical services (DNS, DHCP, AD, etc.) can handle the load without starvation during a failover."
  },
  {
    "id": 333,
    "topic_id": 1,
    "title": "An ISP imposes a monthly bandwidth cap that could be exceeded during a DR event. What should be addressed in the DR plan?",
    "description": "The plan should verify that the ISP can provide enough capacity or negotiate uncapped bandwidth for disaster scenarios to prevent throttling or traffic blockage during recovery."
  },
  {
    "id": 334,
    "topic_id": 1,
    "title": "List the primary trade\u2011offs between cold, warm, and hot DR sites.",
    "description": "Cold sites are lowest cost but have the longest RTO and require manual provisioning; warm sites balance cost and RTO with critical data pre\u2011synced but infrastructure offline; hot sites are most expensive but provide near\u2011zero RTO and RPO by keeping full infrastructure active."
  },
  {
    "id": 335,
    "topic_id": 1,
    "title": "After implementing a disaster recovery plan, what critical step should be performed regularly?",
    "description": "The DR plan must be tested against documented procedures to uncover gaps, and then reviewed and updated periodically to reflect changing requirements and environments."
  },
  {
    "id": 336,
    "topic_id": 1,
    "title": "Define Disaster Recovery as a Service (DRaaS) and mention one major benefit and one potential risk.",
    "description": "DRaaS is a third\u2011party offering that provides off\u2011site DR capabilities, delivering short RPO/RTO without the customer needing to build its own infrastructure; a benefit is reduced capital expense, while a risk is reliance on the provider\u2019s ability to meet recovery objectives."
  },
  {
    "id": 337,
    "topic_id": 1,
    "title": "What is business continuity in the context of cloud operations?",
    "description": "Business continuity is the ability to recover to an operational state quickly after a failure or outage."
  },
  {
    "id": 338,
    "topic_id": 1,
    "title": "Define Recovery Point Objective (RPO) and Recovery Time Objective (RTO).",
    "description": "RPO is the maximum amount of data loss tolerated during an outage, while RTO is the maximum time a system can remain offline before service must be restored."
  },
  {
    "id": 339,
    "topic_id": 1,
    "title": "What is the difference between an alternate disaster\u2011recovery site and an edge location?",
    "description": "An alternate site is a geographically separated full data center used for complete failover, whereas an edge location is a point\u2011of\u2011presence that provides low\u2011latency connectivity and caching but is not a full operational data center."
  },
  {
    "id": 340,
    "topic_id": 1,
    "title": "Why is it critical to test a disaster\u2011recovery design against its documentation after implementation?",
    "description": "Testing validates the design, uncovers unforeseen process or technical issues, and ensures the plan works as intended so modifications can be made before a real event."
  },
  {
    "id": 341,
    "topic_id": 1,
    "title": "Your organization must meet HIPAA requirements and needs a disaster\u2011recovery site. Which factors most influence the selection of an alternate site?",
    "description": "Factors include required geographical separation, the provider\u2019s HIPAA certification, regional availability zones, and any data\u2011residency or in\u2011country storage restrictions."
  },
  {
    "id": 342,
    "topic_id": 1,
    "title": "How should network\u2011connectivity requirements be expressed in a DR service\u2011level agreement?",
    "description": "The SLA should specify the required bandwidth, guaranteed capacity, and performance commitments for peak usage and replication traffic, along with response times for any failures."
  },
  {
    "id": 343,
    "topic_id": 1,
    "title": "What does a disaster\u2011recovery SLA typically include?",
    "description": "It outlines responsibilities for DR, and defines key metrics such as RPO, RTO, availability levels, and response times for critical events."
  },
  {
    "id": 344,
    "topic_id": 1,
    "title": "During a large\u2011scale outage that disables the primary data center, list the order of steps required to restore services based on described dependencies.",
    "description": "First, activate servers and networking at the backup location; next, bring up the database using current replicas; finally, reconnect and start the dependent applications."
  },
  {
    "id": 345,
    "topic_id": 1,
    "title": "What is the key difference in equipment procurement between using a cloud\u2011based backup site and a traditional on\u2011premises backup site?",
    "description": "A cloud backup site requires no capital equipment purchase because the provider supplies it, while a traditional backup site demands full servers, storage, networking gear, and software, incurring significant CAPEX."
  },
  {
    "id": 346,
    "topic_id": 1,
    "title": "If a DR plan requires IT staff to work on\u2011site at the recovery data center, what pre\u2011deployment actions must be taken to ensure access?",
    "description": "Arrange security clearance and service tickets in advance, schedule escort and equipment inspection, and obtain detailed directions to the secure, often nondescript facility."
  },
  {
    "id": 347,
    "topic_id": 1,
    "title": "What is a maintenance window in cloud operations?",
    "description": "A maintenance window is a scheduled time period during which changes or maintenance activities are performed, chosen to minimize impact on business operations."
  },
  {
    "id": 348,
    "topic_id": 1,
    "title": "Define orphaned resources in a cloud environment.",
    "description": "Orphaned resources are unused cloud assets that remain provisioned after the service that created them has been terminated, continuing to incur charges."
  },
  {
    "id": 349,
    "topic_id": 1,
    "title": "What is the difference between log file archiving and log file clearing?",
    "description": "Archiving moves logs to a secure, long\u2011term storage for later analysis, while clearing deletes logs from the active system after they have been archived or are no longer needed."
  },
  {
    "id": 350,
    "topic_id": 1,
    "title": "How would you use an automation tool such as Ansible to perform non\u2011intrusive maintenance on a multi\u2011AZ deployment?",
    "description": "Create playbooks that drain instances, take snapshots, and trigger failover actions in each availability zone during the defined maintenance window, ensuring updates occur without service interruption."
  },
  {
    "id": 351,
    "topic_id": 1,
    "title": "A retailer must avoid changes during the holiday selling season. What steps should the operations team take when defining maintenance windows?",
    "description": "Identify peak sales periods, lock the change calendar for those dates, and schedule all non\u2011critical updates outside the holiday weeks, documenting the restriction in the change\u2011management policy."
  },
  {
    "id": 352,
    "topic_id": 1,
    "title": "What are stale DNS entries and why must they be removed?",
    "description": "Stale DNS entries are records that point to resources that no longer exist; removing them improves DNS performance and simplifies troubleshooting."
  },
  {
    "id": 353,
    "topic_id": 1,
    "title": "When compressing storage on a production database volume, what precaution should be taken?",
    "description": "Schedule the compression task during a maintenance window to avoid degrading I/O performance for active database operations."
  },
  {
    "id": 354,
    "topic_id": 1,
    "title": "How do firewall rule reviews differ from ACL maintenance?",
    "description": "Firewall rule reviews focus on perimeter inbound/outbound traffic policies, while ACL maintenance deals with subnet\u2011level allow/deny lists and OS object permissions; both require periodic validation but operate at different layers."
  },
  {
    "id": 355,
    "topic_id": 1,
    "title": "After terminating a VM, an unattached storage volume remains and incurs charges. What process should be implemented to prevent this?",
    "description": "Deploy a post\u2011termination script or automation that checks for dependent resources, detaches and deletes any orphaned volumes, and logs the action for audit purposes."
  },
  {
    "id": 356,
    "topic_id": 1,
    "title": "What steps are involved in a post\u2011mortem analysis after an unplanned maintenance event?",
    "description": "Restore services, document the timeline, identify root causes, assess impact, and update procedures to mitigate future occurrences."
  },
  {
    "id": 357,
    "topic_id": 1,
    "title": "What is the archival process used for in cloud environments?",
    "description": "It moves data to long\u2011term, offsite storage for retention and cost\u2011effective preservation."
  },
  {
    "id": 358,
    "topic_id": 1,
    "title": "Define Disaster Recovery as a Service (DRaaS) and its primary function.",
    "description": "DRaaS is a cloud\u2011based offering where providers handle failover, testing, and restoration of workloads after a disruption."
  },
  {
    "id": 359,
    "topic_id": 1,
    "title": "What is the difference between Business Continuity and Disaster Recovery?",
    "description": "Business Continuity ensures an organization can keep delivering products and services during any disruption, while Disaster Recovery focuses on restoring IT systems and data after a specific outage."
  },
  {
    "id": 360,
    "topic_id": 1,
    "title": "An organization can tolerate losing at most 4\u202fGB of data after an outage. Which metric should they set, and what does it represent?",
    "description": "They should set the Recovery Point Objective (RPO) to 4\u202fGB, which defines the maximum data loss acceptable during a failure."
  },
  {
    "id": 361,
    "topic_id": 1,
    "title": "When a security service provider inventories accounts and removes inactive ones, what term describes those accounts?",
    "description": "They are called stale accounts."
  },
  {
    "id": 362,
    "topic_id": 1,
    "title": "Define data replication in the context of multi\u2011data\u2011center cloud deployments.",
    "description": "Data replication is the transfer and synchronization of data across multiple data centers to maintain consistency and availability."
  },
  {
    "id": 363,
    "topic_id": 1,
    "title": "What do the acronyms RPO and RTO stand for, and how do they differ?",
    "description": "RPO is Recovery Point Objective (maximum data loss), and RTO is Recovery Time Objective (maximum downtime); RPO measures data, RTO measures time."
  },
  {
    "id": 364,
    "topic_id": 1,
    "title": "After terminating a cloud service, leftover resources are discovered. What are these resources called and why must they be addressed?",
    "description": "They are orphaned services; they should be removed to avoid unnecessary costs and potential security exposure."
  },
  {
    "id": 365,
    "topic_id": 1,
    "title": "What is an active\u2011active replication system and what advantage does it provide?",
    "description": "Active\u2011active replication writes data to multiple sites simultaneously, ensuring continuous availability and zero\u2011loss synchronization."
  },
  {
    "id": 366,
    "topic_id": 1,
    "title": "Why is consolidating audit logs on a central server important for cloud security?",
    "description": "It enables unified review and auditing of all generated logs, simplifying detection of anomalies and compliance reporting."
  },
  {
    "id": 367,
    "topic_id": 3,
    "title": "What is a cloud metric?",
    "description": "A cloud metric is a standard of measurement that defines the conditions and rules for performing a measurement and interpreting its results for cloud resources."
  },
  {
    "id": 368,
    "topic_id": 3,
    "title": "Define a baseline in the context of cloud monitoring.",
    "description": "A baseline is a reference measurement of a cloud resource\u2019s normal performance, established by sampling at an appropriate interval to identify typical behavior and variance."
  },
  {
    "id": 369,
    "topic_id": 3,
    "title": "When configuring an alert for CPU utilization, how would you use a baseline to set the trigger threshold?",
    "description": "First determine the normal CPU range from the baseline (e.g., 70% average), then configure the alert to fire when utilization exceeds a defined variance, such as 95% average over a ten\u2011minute window."
  },
  {
    "id": 370,
    "topic_id": 3,
    "title": "What is the difference between an anomaly and a baseline?",
    "description": "A baseline represents expected, normal metric values, while an anomaly is any measurement that deviates above or below that baseline beyond an acceptable variance."
  },
  {
    "id": 371,
    "topic_id": 3,
    "title": "In a scenario where a newly added network ACL blocks database access, how does event correlation help resolve the issue?",
    "description": "Event correlation aggregates the resulting alarms\u2014web server timeouts, zero database reads, etc.\u2014and identifies the ACL change as the root cause, allowing rapid remediation."
  },
  {
    "id": 372,
    "topic_id": 3,
    "title": "What purpose does an event collection policy serve in cloud operations?",
    "description": "It defines reusable rules that automatically generate and forward specific events (e.g., a syslog when storage reaches 75% capacity), reducing manual configuration and ensuring consistency."
  },
  {
    "id": 373,
    "topic_id": 3,
    "title": "Define a push notification service in the context of cloud alerts.",
    "description": "A push service receives a triggered alarm, publishes it to a notification service, and immediately delivers the alert to subscribed endpoints such as SMS, email, or mobile apps."
  },
  {
    "id": 374,
    "topic_id": 3,
    "title": "How can baselines be used to forecast required cloud resources?",
    "description": "By analyzing baseline trends over time, you can predict future utilization patterns and proactively add or remove capacity\u2014such as provisioning extra read replicas when query latency rises."
  },
  {
    "id": 375,
    "topic_id": 3,
    "title": "What distinguishes the shared responsibility model for IaaS, PaaS, and SaaS?",
    "description": "In IaaS, the provider manages hardware only; in PaaS, the provider also manages the operating system; in SaaS, the provider is responsible for the application, OS, and infrastructure, leaving the customer with only data and usage responsibilities."
  },
  {
    "id": 376,
    "topic_id": 3,
    "title": "In a change management process, when should the Change Advisory Board (CAB) intervene, and why?",
    "description": "The CAB reviews, sequences, and approves change requests before implementation to identify conflicts, assess risk, and ensure adequate resources, thereby preventing unplanned disruptions."
  },
  {
    "id": 377,
    "topic_id": 3,
    "title": "What is cloud bursting?",
    "description": "Cloud bursting is a hybrid model where an organization normally uses on\u2011premises resources but temporarily provisions public\u2011cloud resources to handle increased load, then decommissions them when the load returns to normal."
  },
  {
    "id": 378,
    "topic_id": 3,
    "title": "What is the difference between vertical scaling and horizontal scaling?",
    "description": "Vertical scaling (scale\u2011up) adds capacity such as CPU, RAM, or storage to an existing VM and often requires downtime, whereas horizontal scaling (scale\u2011out) adds additional instances to a distributed architecture, allowing scaling without taking resources offline."
  },
  {
    "id": 379,
    "topic_id": 3,
    "title": "When should you implement an autoscaling policy?",
    "description": "You should use autoscaling when you want resources to be added or removed automatically based on defined metrics (e.g., CPU utilization) to match workload demand while controlling cost and avoiding manual intervention."
  },
  {
    "id": 380,
    "topic_id": 3,
    "title": "Your on\u2011premises data center is at capacity and you expect a one\u2011day traffic spike. How would you handle this using cloud resources?",
    "description": "Implement cloud bursting: temporarily provision public\u2011cloud instances to absorb the spike, route traffic to them (e.g., via a load balancer), and decommission the instances once the spike subsides."
  },
  {
    "id": 381,
    "topic_id": 3,
    "title": "Define diagonal scaling.",
    "description": "Diagonal scaling combines vertical scaling (using more powerful instances) with horizontal scaling (adding more instances) to meet demand, often applying vertical scaling to backend services and horizontal scaling to front\u2011end tiers."
  },
  {
    "id": 382,
    "topic_id": 3,
    "title": "What is the difference between user\u2011based policies and resource\u2011based policies?",
    "description": "User\u2011based policies are attached to identities and grant permissions to users or groups, while resource\u2011based policies are attached directly to a resource and specify who may access it; deny rules generally override allow rules across both types."
  },
  {
    "id": 383,
    "topic_id": 3,
    "title": "A SaaS email provider you use is being retired. What steps must you verify before migrating to a new provider?",
    "description": "Confirm that you can export existing mailboxes, ensure the new provider can import them, check for any version incompatibilities that may require conversion, and review any contractual or financial obligations to avoid stranded resources."
  },
  {
    "id": 384,
    "topic_id": 3,
    "title": "How can you automate user account creation across both on\u2011premises LDAP and a cloud IAM service?",
    "description": "Create a script that reads user role data from a source (e.g., spreadsheet or database) and calls the LDAP API and the cloud IAM API to create the accounts and assign appropriate permissions, optionally scheduling the script to run regularly."
  },
  {
    "id": 385,
    "topic_id": 3,
    "title": "What is elasticity in cloud computing?",
    "description": "Elasticity is the ability to dynamically add and remove resources on the fly to match workload demand, giving the appearance of an unlimited pool of compute, storage, and networking resources."
  },
  {
    "id": 386,
    "topic_id": 3,
    "title": "Your organization wants to limit cloud spend by oversubscribing resources. Explain how oversubscription works and a potential risk.",
    "description": "Oversubscription provisions only enough resources for normal workload, relying on occasional spikes exceeding capacity; the risk is that during those spikes performance may degrade because the allocated resources are insufficient."
  },
  {
    "id": 387,
    "topic_id": 3,
    "title": "What term describes a standard of measurement that defines the conditions and rules for performing a measurement and for understanding its results?",
    "description": "A metric."
  },
  {
    "id": 388,
    "topic_id": 3,
    "title": "What type of system uses metrics data and predefined thresholds to automatically react to events across all layers of a cloud deployment?",
    "description": "An automated monitoring system."
  },
  {
    "id": 389,
    "topic_id": 3,
    "title": "When a baseline is established for normal operations, what is the term for a condition that deviates from that baseline, either above or below expectations?",
    "description": "An anomaly."
  },
  {
    "id": 390,
    "topic_id": 3,
    "title": "Which component can be configured to generate notifications when a critical event is detected in a monitoring system?",
    "description": "An alert (or alert rule)."
  },
  {
    "id": 391,
    "topic_id": 3,
    "title": "In the shared responsibility model, who is generally responsible for the underlying infrastructure of a cloud service?",
    "description": "The cloud provider."
  },
  {
    "id": 392,
    "topic_id": 3,
    "title": "Where are the responsibilities for underlying infrastructure typically documented in a cloud contract?",
    "description": "In the Service Level Agreement (SLA)."
  },
  {
    "id": 393,
    "topic_id": 3,
    "title": "What process involves managing all aspects of ongoing upgrades, repairs, and reconfigurations of cloud resources?",
    "description": "Patch management."
  },
  {
    "id": 394,
    "topic_id": 3,
    "title": "What term describes the management of a software application from initial planning through to retirement?",
    "description": "Application lifecycle management (ALM)."
  },
  {
    "id": 395,
    "topic_id": 3,
    "title": "What can be granted to users at the account level to allow them to add, remove, or modify user accounts and services?",
    "description": "Permissions (or privileges)."
  },
  {
    "id": 396,
    "topic_id": 3,
    "title": "What security control requires passwords to be at least eight characters, include an uppercase letter, a special character, and not be a dictionary word?",
    "description": "A password policy."
  },
  {
    "id": 397,
    "topic_id": 3,
    "title": "In a change request document, what term describes the step to revert modifications if the implementation fails?",
    "description": "Rollback."
  },
  {
    "id": 398,
    "topic_id": 1,
    "title": "What is a baseline in cloud performance monitoring?",
    "description": "A baseline is a documented set of normal operational metrics (CPU, memory, network, storage, etc.) collected over time that defines expected performance and capacity for a cloud deployment."
  },
  {
    "id": 399,
    "topic_id": 1,
    "title": "Define \u201cobject\u201d in the context of cloud monitoring.",
    "description": "In cloud monitoring, an object is a measurable property of a resource, such as the CPU utilization of a VM, that can be reported as a metric."
  },
  {
    "id": 400,
    "topic_id": 1,
    "title": "What is the difference between vertical scaling and horizontal scaling?",
    "description": "Vertical scaling increases resources of a single VM (e.g., larger instance type) and usually requires downtime, while horizontal scaling adds additional VMs to share the load, typically without downtime."
  },
  {
    "id": 401,
    "topic_id": 1,
    "title": "When should you increase the frequency of metric collection from once per hour to every 15 seconds?",
    "description": "Increase frequency when rapid detection of performance issues is needed and the added overhead on resources and the monitoring system is acceptable, such as during high\u2011traffic periods or while troubleshooting intermittent spikes."
  },
  {
    "id": 402,
    "topic_id": 1,
    "title": "Your web server\u2019s CPU utilization consistently exceeds 85\u202f% for a 30\u2011minute window. What steps should you take according to baseline management practices?",
    "description": "First verify the baseline and identify the cause; then consider reducing load (optimizing processes) or scaling\u2014if load cannot be reduced, apply vertical scaling (upgrade to a larger instance) or horizontal scaling (add additional servers) to keep usage below the baseline threshold."
  },
  {
    "id": 403,
    "topic_id": 1,
    "title": "What are the four primary network performance metrics to monitor for baseline validation?",
    "description": "Capacity (maximum bandwidth), jitter (variable latency), latency (time for a packet to travel), and packet loss (percentage of dropped packets)."
  },
  {
    "id": 404,
    "topic_id": 1,
    "title": "How can audit logging help during a security breach investigation in a cloud environment?",
    "description": "Audit logs record when monitoring configurations are changed or disabled, providing evidence of potential tampering and a timeline of actions that can be examined to understand the breach\u2019s impact."
  },
  {
    "id": 405,
    "topic_id": 1,
    "title": "How does monitoring RAM usage differ in impact from monitoring CPU usage?",
    "description": "RAM usage monitoring focuses on preventing memory exhaustion that can cause application crashes and typically requires a reboot to add memory, whereas CPU usage monitoring can often be addressed by process optimization or scaling without immediate downtime."
  },
  {
    "id": 406,
    "topic_id": 1,
    "title": "After applying a new OS patch, your storage I/O latency has increased beyond the baseline. What validation steps should you perform?",
    "description": "Conduct a post\u2011patch baseline validation by collecting storage I/O metrics, compare them to pre\u2011patch data, analyze the delta, and if necessary, adjust configuration or revert the patch to restore performance."
  },
  {
    "id": 407,
    "topic_id": 1,
    "title": "How can tags be used to improve cost reporting in a multi\u2011environment cloud deployment?",
    "description": "Assign tags such as \u201cEnvironment: Production\u201d or \u201cProject: X\u201d to resources; then filter cost reports by those tags to break down spending per environment or project, enabling precise chargeback and budgeting."
  },
  {
    "id": 408,
    "topic_id": 1,
    "title": "What term describes the measurements used to detail resource usage under normal operations?",
    "description": "Baseline measurements are the reference metrics that show typical resource consumption during normal operation."
  },
  {
    "id": 409,
    "topic_id": 1,
    "title": "Define a metric in the context of cloud monitoring.",
    "description": "A metric is a single piece of data collected from an object, such as CPU utilization or network throughput."
  },
  {
    "id": 410,
    "topic_id": 1,
    "title": "What are cloud components that data can be gathered from called?",
    "description": "These components are referred to as metrics."
  },
  {
    "id": 411,
    "topic_id": 1,
    "title": "When should horizontal scaling be used, and what does it involve?",
    "description": "Horizontal scaling should be used when additional capacity is needed by deploying more servers, spreading the load across multiple instances."
  },
  {
    "id": 412,
    "topic_id": 1,
    "title": "A virtual machine is experiencing high swap file usage. What is a direct way to reduce this condition?",
    "description": "Add extra RAM to the VM, which reduces reliance on the swap file."
  },
  {
    "id": 413,
    "topic_id": 1,
    "title": "What does high network latency indicate?",
    "description": "High network latency indicates delays and slowdowns caused by the network, often due to congestion or long transmission paths."
  },
  {
    "id": 414,
    "topic_id": 1,
    "title": "What cloud capability allows resources to automatically scale up and down based on demand?",
    "description": "Elasticity is the ability of cloud resources to expand and contract automatically in response to workload changes."
  },
  {
    "id": 415,
    "topic_id": 1,
    "title": "In which document does a service provider specify performance guarantees?",
    "description": "Performance guarantees are outlined in a Service Level Agreement (SLA)."
  },
  {
    "id": 416,
    "topic_id": 1,
    "title": "Explain vertical scaling and when it is typically applied.",
    "description": "Vertical scaling (or scaling up) replaces a machine image with a larger, more powerful one, adding CPU, memory, or storage to a single server to handle increased load."
  },
  {
    "id": 417,
    "topic_id": 1,
    "title": "For compliance purposes, what ongoing process must be implemented to retain operational data?",
    "description": "An ongoing logging process must be implemented, capturing and storing logs for the required retention period."
  },
  {
    "id": 418,
    "topic_id": 2,
    "title": "What is an incident in cloud operations?",
    "description": "An incident is any event that threatens to interrupt normal operations and is considered disruptive to the organization."
  },
  {
    "id": 419,
    "topic_id": 2,
    "title": "List the primary steps of the incident management process.",
    "description": "Identify and categorize the incident, log it, prioritize it, respond to it, and validate that it has been resolved."
  },
  {
    "id": 420,
    "topic_id": 2,
    "title": "What is the difference between troubleshooting automation issues that are provider\u2011managed versus those that are organization\u2011developed?",
    "description": "Provider\u2011managed automation can only be investigated via logs, dashboards, and support tickets with the provider, while organization\u2011developed automation allows direct access to script logs, API calls, and code for internal debugging."
  },
  {
    "id": 421,
    "topic_id": 2,
    "title": "When you notice a discrepancy between your deployment plan and the actual cloud resources, what should you do first?",
    "description": "Review the relevant logs (e.g., API call logs) to determine whether the automation scripts executed as expected and identify any failures."
  },
  {
    "id": 422,
    "topic_id": 2,
    "title": "A VPN connection between your data center and the cloud drops repeatedly. Which troubleshooting steps should you follow?",
    "description": "Check the VPN console and on\u2011premises VPN device for status and error logs, verify link\u2011level statistics, and consult the provider\u2019s health dashboard for any upstream issues."
  },
  {
    "id": 423,
    "topic_id": 2,
    "title": "Define resource contention and resource starvation in a cloud environment.",
    "description": "Resource contention occurs when multiple workloads compete for limited resources (CPU, memory, bandwidth), while resource starvation is the resulting performance slowdown when a workload cannot obtain the resources it needs."
  },
  {
    "id": 424,
    "topic_id": 2,
    "title": "How can autoscaling help prevent resource contention issues?",
    "description": "Autoscaling automatically adds capacity when utilization thresholds are exceeded, ensuring sufficient resources are available before contention degrades performance."
  },
  {
    "id": 425,
    "topic_id": 2,
    "title": "How does licensing responsibility differ between IaaS/PaaS and SaaS service models?",
    "description": "In IaaS and PaaS, the customer installs and manages applications and therefore handles licensing; in SaaS, the provider owns the application and manages all licensing issues."
  },
  {
    "id": 426,
    "topic_id": 2,
    "title": "A TLS certificate expires and causes a service outage. What preventive measure should be in place to avoid this?",
    "description": "Implement a process to track certificate expiration dates and use automatic renewal mechanisms provided by the certificate authority."
  },
  {
    "id": 427,
    "topic_id": 2,
    "title": "During a service outage, you need to coordinate multiple teams quickly. What structures and preparations described help facilitate this response?",
    "description": "Establish a war room with audio/video collaboration tools, maintain documented call trees for rapid notification, and conduct tabletop exercises to clarify roles and evidence\u2011preservation procedures."
  },
  {
    "id": 428,
    "topic_id": 2,
    "title": "What is the definition of capacity in the context of cloud resources?",
    "description": "Capacity is the maximum amount that a cloud object or service can contain or handle, representing its limit for workload processing."
  },
  {
    "id": 429,
    "topic_id": 2,
    "title": "Define API request capacity and how it is typically measured.",
    "description": "API request capacity is the maximum number of API calls a service can handle, usually measured in requests per second, and is a metered, throttled resource."
  },
  {
    "id": 430,
    "topic_id": 2,
    "title": "What is the difference between vertical scaling and horizontal scaling when addressing CPU starvation?",
    "description": "Vertical scaling upgrades a single VM to a more powerful instance (often requiring downtime), while horizontal scaling adds more VMs to distribute the load across multiple servers."
  },
  {
    "id": 431,
    "topic_id": 2,
    "title": "In a situation where a database writes exceed the API limit of 100 requests per second, what troubleshooting steps should you take?",
    "description": "Review API error logs for throttling messages, compare actual request rates to the baseline, and either increase the contracted API capacity or distribute the writes across additional interfaces."
  },
  {
    "id": 432,
    "topic_id": 2,
    "title": "How can you mitigate network bandwidth bottlenecks for applications that require low latency and high speed?",
    "description": "Place all VMs in the same placement group, use high\u2011speed network adapters (e.g., 10\u202fGbps or higher), and ensure the underlying internet connection is provisioned with sufficient bandwidth."
  },
  {
    "id": 433,
    "topic_id": 2,
    "title": "If a CIDR block was sized too small during deployment, what are the potential consequences and how can they be remedied?",
    "description": "The subnet will run out of IP addresses, forcing redeployment or extensive reconfiguration of resources; remediation typically requires creating a larger CIDR block and migrating or recreating affected resources."
  },
  {
    "id": 434,
    "topic_id": 2,
    "title": "Why can excessive storage\u2011capacity alerts lead to alert fatigue, and how should alerts be configured to avoid this?",
    "description": "If alerts fire for normal usage patterns (e.g., a temporary\u2011file system at 100\u202f% utilization), users may start ignoring them; configure alerts at thresholds that reflect abnormal growth relative to the baseline."
  },
  {
    "id": 435,
    "topic_id": 2,
    "title": "What is the primary difference between IPv4 and IPv6 address spaces, and why has IPv6 not replaced IPv4 in most organizations?",
    "description": "IPv6 provides a vastly larger address space than IPv4, but it requires a complete network overhaul and separate protocol implementation, making the migration cost\u2011prohibitive for many organizations."
  },
  {
    "id": 436,
    "topic_id": 2,
    "title": "When a large batch job strains a relational database, what mitigation strategies should be employed?",
    "description": "Ensure the database has sufficient write capacity, add read replicas for read\u2011intensive workloads, and consider autoscaling compute resources to handle the temporary load increase."
  },
  {
    "id": 437,
    "topic_id": 2,
    "title": "During a sudden spike in concurrent users, which metrics would you examine to pinpoint congestion points in the cloud deployment?",
    "description": "Review CPU and memory utilization per VM, API request rates, network I/O, and storage volume usage against their baselines to identify the overloaded component."
  },
  {
    "id": 438,
    "topic_id": 2,
    "title": "What does the shared responsibility model limit you to when troubleshooting automation and orchestration in a public cloud?",
    "description": "It limits you to examining the inputs you control\u2014templates and configuration items\u2014while the cloud provider manages the underlying automation services."
  },
  {
    "id": 439,
    "topic_id": 2,
    "title": "How can you verify that an automation template produced the expected result?",
    "description": "Compare the template (input) to the actual deployed resources (output) to confirm the requested configuration was delivered."
  },
  {
    "id": 440,
    "topic_id": 2,
    "title": "What is the difference between an account mismatch and a change management breakdown?",
    "description": "An account mismatch involves incorrect user or group privileges in the identity console, whereas a change management breakdown occurs when coordinated operational changes conflict or are not properly sequenced."
  },
  {
    "id": 441,
    "topic_id": 2,
    "title": "During a server patch rollout, the network team schedules overlapping downtime. What immediate action should the server team take according to change management best practices?",
    "description": "Pause the patch installation, follow the contingency plan, verify network status, and be prepared to roll back changes if the network remains unavailable."
  },
  {
    "id": 442,
    "topic_id": 2,
    "title": "Define the purpose of the nslookup utility in DNS troubleshooting.",
    "description": "nslookup queries a DNS server for specific records and returns the associated IP address or an error, allowing verification of DNS entries."
  },
  {
    "id": 443,
    "topic_id": 2,
    "title": "If a service becomes unreachable after moving a load balancer to a new IP address, what DNS-related step should you check first?",
    "description": "Confirm that the DNS record for the service has been updated to point to the new IP address."
  },
  {
    "id": 444,
    "topic_id": 2,
    "title": "After an overnight patch an application fails to start due to a version incompatibility. What investigative steps should you follow?",
    "description": "Ask stakeholders what changed, review log files for error details, and determine whether a recent patch or upgrade introduced the incompatibility."
  },
  {
    "id": 445,
    "topic_id": 2,
    "title": "How do IP address changes differ from DNS record changes in terms of required follow\u2011up actions?",
    "description": "IP address changes require updating DNS records, ACLs, firewall rules, routing tables, and reconfiguring device interfaces, while DNS changes only involve modifying the name\u2011to\u2011address mapping."
  },
  {
    "id": 446,
    "topic_id": 2,
    "title": "What is a deployment model change, and why is testing emphasized before performing it?",
    "description": "A deployment model change is migrating workloads between service providers or cloud models (e.g., on\u2011prem to SaaS); testing in a separate environment ensures the migration works and reduces risk."
  },
  {
    "id": 447,
    "topic_id": 2,
    "title": "Your organization moves a workload from one availability zone to another and experiences intermittent connectivity. Which troubleshooting steps align with guidance on location changes?",
    "description": "Verify that standby resources are provisioned, confirm DNS and routing updates, and review the change\u2011management plan to ensure proper testing and validation were performed."
  },
  {
    "id": 448,
    "topic_id": 2,
    "title": "What term describes software representations of network systems in a cloud environment?",
    "description": "Virtual networks are software\u2011defined representations of network topologies and services."
  },
  {
    "id": 449,
    "topic_id": 2,
    "title": "What service allows all devices in a cloud deployment to synchronize to a central time source?",
    "description": "A Network Time Protocol (NTP) server provides a centralized time service for all devices."
  },
  {
    "id": 450,
    "topic_id": 2,
    "title": "Define capacity in the context of cloud resources.",
    "description": "Capacity is the maximum amount of workload or data that a resource can contain or support."
  },
  {
    "id": 451,
    "topic_id": 2,
    "title": "When CPU capacity starvation occurs, what two scaling actions can you take?",
    "description": "You can either scale out horizontally by adding more instances, or scale up vertically by increasing the CPU resources of existing instances."
  },
  {
    "id": 452,
    "topic_id": 2,
    "title": "What is the primary difference between scaling out and scaling up?",
    "description": "Scaling out adds additional instances (horizontal expansion), while scaling up increases the resources of a single instance (vertical expansion)."
  },
  {
    "id": 453,
    "topic_id": 2,
    "title": "Expansion planning can be unexpectedly challenged by two common factors. Identify them and explain why they affect planning.",
    "description": "Budget constraints limit available funding for additional resources, and resource limitations (such as limited IP address space or compute quotas) restrict how much you can expand."
  },
  {
    "id": 454,
    "topic_id": 2,
    "title": "What does DNS map, and what is the purpose of that mapping?",
    "description": "DNS maps a domain name to an IP address, enabling users to access services using readable names instead of numeric addresses."
  },
  {
    "id": 455,
    "topic_id": 2,
    "title": "After implementing a configuration change in a cloud service, what verification step should you always perform?",
    "description": "You should always verify that the change is working as expected by testing functionality or checking monitoring data."
  },
  {
    "id": 456,
    "topic_id": 2,
    "title": "What is a log aggregation service and how does it assist during troubleshooting?",
    "description": "A log aggregation service centrally collects device and application logs, allowing analysts to correlate events and identify root causes more efficiently."
  },
  {
    "id": 457,
    "topic_id": 2,
    "title": "Why are snapshot backups valuable for restoring a failed cloud service?",
    "description": "Snapshot backups capture the state of a service at a point in time, enabling rapid restoration without rebuilding the entire environment."
  },
  {
    "id": 458,
    "topic_id": 2,
    "title": "How do proper network diagrams aid cloud administrators?",
    "description": "Network diagrams provide a visual representation of the deployment, making it easier to understand topology, locate issues, and plan changes."
  },
  {
    "id": 459,
    "topic_id": 6,
    "title": "What is the purpose of a subnet mask in an IPv4 network?",
    "description": "A subnet mask defines which portion of an IP address identifies the network and which portion identifies the host, allowing devices to determine if a destination is local or must be reached via a gateway."
  },
  {
    "id": 460,
    "topic_id": 6,
    "title": "How would you verify whether a duplicate IP address is causing intermittent connectivity loss?",
    "description": "Run a continuous ping to a host on the same subnet and inspect the ARP table for a MAC address that changes for the same IP, indicating duplicate assignment."
  },
  {
    "id": 461,
    "topic_id": 6,
    "title": "What is the difference between a default gateway and a regular router interface?",
    "description": "A default gateway is the specific IP address of a router\u2019s interface on the local subnet that forwards traffic destined for external networks, while a router may have many interfaces for various subnets."
  },
  {
    "id": 462,
    "topic_id": 6,
    "title": "When troubleshooting a host that can ping other devices on its subnet but cannot reach the Internet, what is the first configuration element you should check?",
    "description": "Verify that the host\u2019s default gateway IP address is correctly configured and reachable."
  },
  {
    "id": 463,
    "topic_id": 6,
    "title": "What is the primary effect of enabling jumbo frames on a storage network?",
    "description": "Jumbo frames increase the Ethernet payload size, reducing per\u2011packet overhead and improving throughput for large storage transfers."
  },
  {
    "id": 464,
    "topic_id": 6,
    "title": "In a scenario where latency spikes are observed on a cloud\u2011hosted application, which tool would you use to measure round\u2011trip time and packet loss?",
    "description": "Use the ping utility to send ICMP echo requests and observe response times and any lost packets."
  },
  {
    "id": 465,
    "topic_id": 6,
    "title": "How does Quality of Service (QoS) help mitigate network congestion?",
    "description": "QoS prioritizes critical traffic by allocating bandwidth or shaping traffic, ensuring important packets are delivered even when the network is congested."
  },
  {
    "id": 466,
    "topic_id": 6,
    "title": "What is the difference between VLAN (802.1Q) and VXLAN identifiers?",
    "description": "VLAN IDs are 12\u2011bit values limited to 4,094 usable VLANs, whereas VXLAN uses a 24\u2011bit VNI, allowing millions of virtual networks."
  },
  {
    "id": 467,
    "topic_id": 6,
    "title": "In a cloud environment, a user reports that a web service cannot resolve its domain name. Which command should be used first to isolate the problem?",
    "description": "Run nslookup (or dig) against the configured DNS server to verify name resolution and identify any DNS errors."
  },
  {
    "id": 468,
    "topic_id": 6,
    "title": "What is the difference between the Windows command `tracert` and the Linux command `traceroute`?",
    "description": "`tracert` is the Windows implementation of the traceroute utility, while `traceroute` is the equivalent command on Linux systems; both display the path and latency of each hop to a destination."
  },
  {
    "id": 469,
    "topic_id": 6,
    "title": "When should you prefer using SSH over Telnet for remote device access?",
    "description": "SSH should be used whenever encryption and authentication are required, as it secures the session, whereas Telnet transmits credentials in clear text."
  },
  {
    "id": 470,
    "topic_id": 6,
    "title": "What is the impact of a mis\u2011configured VLAN trunk on inter\u2011switch traffic?",
    "description": "If the VLAN is not allowed on the trunk, traffic for that VLAN cannot pass between switches, causing loss of connectivity for devices on that VLAN."
  },
  {
    "id": 471,
    "topic_id": 6,
    "title": "How can you use the `route` command to diagnose a routing issue on a Linux host?",
    "description": "Execute `route` (or `ip route`) to display the host\u2019s routing table and verify that routes to the destination network exist and are correctly configured."
  },
  {
    "id": 472,
    "topic_id": 6,
    "title": "What is the primary responsibility of the cloud provider when a VXLAN issue occurs?",
    "description": "VXLAN is considered infrastructure, so the cloud provider is responsible for diagnosing and resolving VXLAN\u2011related problems."
  },
  {
    "id": 473,
    "topic_id": 6,
    "title": "What is privilege escalation in a cloud environment?",
    "description": "Privilege escalation is when a user obtains account privileges that exceed what they are authorized to have, such as gaining administrative rights without proper approval."
  },
  {
    "id": 474,
    "topic_id": 6,
    "title": "How can you reduce the risk of privilege escalation for cloud users?",
    "description": "Grant users only the minimum privileges needed for their duties, keep OS and application patches up\u2011to\u2011date, run applications with least privileges, and enforce mandatory access controls."
  },
  {
    "id": 475,
    "topic_id": 6,
    "title": "What is the difference between authentication and authorization?",
    "description": "Authentication verifies the identity of a user or device, while authorization determines what actions or resources that authenticated identity is allowed to access."
  },
  {
    "id": 476,
    "topic_id": 6,
    "title": "A cloud administrator cannot connect to a virtual machine from the corporate office IP range. Which network access control is most likely causing the denial?",
    "description": "The source IP address is not included in the allowed list of the security group or firewall ACL, resulting in the connection being blocked."
  },
  {
    "id": 477,
    "topic_id": 6,
    "title": "Define federation in the context of cloud identity management.",
    "description": "Federation allows on\u2011premises user accounts (e.g., Active Directory) to be used for authenticating cloud users, consolidating identity management into a single repository."
  },
  {
    "id": 478,
    "topic_id": 6,
    "title": "When troubleshooting a login failure caused by an account lockout, what log information should you review?",
    "description": "Examine authentication logs for entries indicating the number of failed attempts, lockout timestamps, and the specific reason (e.g., exceeded password attempts)."
  },
  {
    "id": 479,
    "topic_id": 6,
    "title": "A TLS certificate error appears after the website\u2019s domain name was changed. What is the most likely cause?",
    "description": "The certificate\u2019s subject names no longer match the new domain, resulting in a hostname mismatch error."
  },
  {
    "id": 480,
    "topic_id": 6,
    "title": "How does extensive device hardening impact subsequent troubleshooting efforts?",
    "description": "Hardening restricts device capabilities, so routine actions like installing or upgrading software often require additional adjustments, increasing the time spent diagnosing and resolving issues."
  },
  {
    "id": 481,
    "topic_id": 6,
    "title": "A VPN connection between on\u2011premises and cloud environments drops intermittently. List three possible causes to investigate.",
    "description": "Investigate routing misconfigurations, incorrect access\u2011control entries, and VPN endpoint health (e.g., session timeouts or ISP connectivity issues)."
  },
  {
    "id": 482,
    "topic_id": 6,
    "title": "What is the principle of least privilege and why is it important for cloud security?",
    "description": "Least privilege means granting users only the permissions required to perform their tasks, reducing the attack surface and limiting potential damage from compromised accounts."
  },
  {
    "id": 483,
    "topic_id": 6,
    "title": "What is troubleshooting?",
    "description": "Troubleshooting is the process of diagnosing the cause of an impairment and resolving the issue."
  },
  {
    "id": 484,
    "topic_id": 6,
    "title": "List the six steps of the troubleshooting process.",
    "description": "Identifying the problem, establishing a theory, testing the theory, establishing and implementing a plan of resolution, verifying the resolution, and documenting the cause and resolution."
  },
  {
    "id": 485,
    "topic_id": 6,
    "title": "What is the difference between top\u2011down and bottom\u2011up troubleshooting approaches?",
    "description": "Top\u2011down starts at the OSI application layer and works downward through the stack, while bottom\u2011up starts at the physical layer and works upward, focusing first on lower\u2011layer issues that affect higher layers."
  },
  {
    "id": 486,
    "topic_id": 6,
    "title": "When should you skip the formal troubleshooting methodology?",
    "description": "When you recognize a known problem and have an immediate solution, making the full step\u2011by\u2011step process unnecessary."
  },
  {
    "id": 487,
    "topic_id": 6,
    "title": "Users report intermittent latency in a web app that uses a shared database. How would you use the \u201cfollow\u2011the\u2011path\u201d approach to narrow the cause?",
    "description": "Run ping/traceroute to verify network connectivity to the database server, check database health and recent change logs, and if both are normal, focus testing on the application layer."
  },
  {
    "id": 488,
    "topic_id": 6,
    "title": "What is the purpose of documenting the cause and resolution after a troubleshooting incident?",
    "description": "Documentation preserves knowledge, provides a reference for future incidents, helps prevent recurrence, and enables others to understand what was done and why."
  },
  {
    "id": 489,
    "topic_id": 6,
    "title": "How can change management procedures affect the implementation of a troubleshooting plan?",
    "description": "The plan must be submitted through (emergency) change management, coordinated with relevant teams, and may require approvals before any modifications are made in the environment."
  },
  {
    "id": 490,
    "topic_id": 6,
    "title": "What is the key distinction between testing a theory in a lab environment versus in production?",
    "description": "Lab testing isolates changes and avoids impact on live users, while production testing risks affecting real services and typically requires a rollback or mitigation plan."
  },
  {
    "id": 491,
    "topic_id": 6,
    "title": "After applying a fix, the original reporter is unavailable to confirm resolution. What steps should you take to verify the resolution?",
    "description": "Monitor relevant logs and performance metrics, run functional tests that replicate the issue, and schedule a follow\u2011up with the user when they become available."
  },
  {
    "id": 492,
    "topic_id": 6,
    "title": "If multiple users report a problem but their descriptions differ, what is the first step to accurately identify the problem?",
    "description": "Correlate the user reports with system logs and metrics to extract valid, relevant data and formulate a clear, concise problem statement."
  },
  {
    "id": 493,
    "topic_id": 6,
    "title": "What network mechanism can be implemented to define priorities when a network becomes saturated?",
    "description": "Quality of Service (QoS) can be implemented to define traffic priorities on a saturated network."
  },
  {
    "id": 494,
    "topic_id": 6,
    "title": "What term describes an Ethernet frame that exceeds the standard maximum size?",
    "description": "A jumbo frame is an Ethernet frame larger than the standard size."
  },
  {
    "id": 495,
    "topic_id": 6,
    "title": "What device is inserted into the middle of a traffic flow, terminates connections in both directions, and monitors traffic between the source and the destination?",
    "description": "A proxy is a device that sits in the middle of a traffic flow, terminates connections both ways, and monitors the traffic."
  },
  {
    "id": 496,
    "topic_id": 6,
    "title": "Which overlay networking technology can create more than 16\u202fmillion isolated virtual networks?",
    "description": "VXLAN (Virtual Extensible LAN) can create over 16\u202fmillion isolated virtual networks."
  },
  {
    "id": 497,
    "topic_id": 6,
    "title": "Which network utility, available on both Windows and Linux, can be used to show open network connections?",
    "description": "The netstat utility displays open network connections on both Windows and Linux."
  },
  {
    "id": 498,
    "topic_id": 6,
    "title": "Name the two utilities that query a DNS server.",
    "description": "The nslookup and dig utilities both query DNS servers."
  },
  {
    "id": 499,
    "topic_id": 6,
    "title": "After a cloud issue has been resolved, what is the final step in the troubleshooting process?",
    "description": "Create documentation (often a post\u2011incident report) that records the problem, actions taken, and resolution."
  },
  {
    "id": 500,
    "topic_id": 6,
    "title": "Once you have identified and articulated the issue, what is the next step in the troubleshooting workflow?",
    "description": "Determine the root cause of the issue and develop a plan of action to resolve it."
  },
  {
    "id": 501,
    "topic_id": 6,
    "title": "Social engineering is a what type of attack?",
    "description": "Social engineering is a non\u2011technical attack that manipulates people to disclose credentials or grant physical access."
  },
  {
    "id": 502,
    "topic_id": 6,
    "title": "A user suddenly has administrative privileges they should not possess. What security condition does this represent?",
    "description": "This situation is an example of privilege escalation."
  },
  {
    "id": 503,
    "topic_id": 200,
    "title": "Know that cloud computing is similar in operation to a utility.",
    "description": "Cloud computing follows the utilities model where a provider will sell computing resources using an as-needed or as-consumed model. This allows a company or individual to pay for only what they use."
  },
  {
    "id": 504,
    "topic_id": 200,
    "title": "Know what cloud computing is.",
    "description": "Cloud computing is a model for enabling convenient, on-demand network access to a shared pool of configurable computing resources (for example, networks, servers, storage, applications, and services) that can be rapidly provisioned and released with minimal management effort or service provider interaction. This cloud model is composed of five essential characteristics, three service models, and four deployment models."
  },
  {
    "id": 505,
    "topic_id": 200,
    "title": "Understand the different cloud service models and how to differentiate between them.",
    "description": "Cloud service models are characterized by the phrase as a service and are accessed by many types of devices, including web browsers, thin clients, and mobile devices. There are three primary service types. Software as a Service, Infrastructure as a Service, and Platform as a Service are the core service offerings. Many cloud service providers offer more descriptive terms in their marketing and sales offerings, including Communications as a Service, Anything as a Service, and Desktop as a Service. However, all of these newer terms fit into the SaaS, IaaS, or PaaS service model. Study the service models and know the differences among IaaS, PaaS, and SaaS as well as the other service models."
  },
  {
    "id": 506,
    "topic_id": 200,
    "title": "Know the primary cloud delivery models.",
    "description": "The four primary cloud delivery models are public, private, community, and hybrid clouds. Know what each one is and its function. It is critical that you understand the way cloud services are delivered in the market today and what they offer."
  },
  {
    "id": 507,
    "topic_id": 200,
    "title": "Be able to identify and explain cloud components.",
    "description": "Common cloud components include applications, automation, compute, networking, security, and storage."
  },
  {
    "id": 508,
    "topic_id": 200,
    "title": "Know the cloud shared resource pooling model and how it is used.",
    "description": "Resource pooling is when the cloud service provider abstracts its physical compute, storage, and networking resources into a group, or pool. The resources from these pools are dynamically allocated to customers on-demand. Resource pooling hides the underlying physical hardware from the customers in such a way that different customers share the underlying infrastructure while their cloud resources remain isolated from each other."
  },
  {
    "id": 509,
    "topic_id": 200,
    "title": "Understand cloud performance components.",
    "description": "The performance you are able to achieve with your deployment is a combination of the capabilities and architecture of the cloud service provider and how you design and implement your operations. Some metrics that you\u2019ll want to consider are bandwidth usage, network latency, storage I/O operations per second (IOPS), and memory utilization."
  },
  {
    "id": 510,
    "topic_id": 200,
    "title": "Be able to explain how autoscaling works.",
    "description": "The ability to automatically and dynamically add resources such as storage, CPUs, memory, and even servers is referred to as elasticity. Using autoscaling, this can be done \u201con the fly\u201d as needed or on a scheduled basis. This allows for cloud consumers to scale up automatically as their workload increases and then have the cloud remove the services after the workload subsides. On-demand cloud services allow the cloud customer to access a self-service portal and instantly create additional servers, storage, processing power, or any other services as required. If the computing workload increases, then additional cloud resources can be created and applied as needed. On-demand allows customers to consume cloud services only as needed and scale back when they are no longer required."
  },
  {
    "id": 511,
    "topic_id": 200,
    "title": "Know what regions and availability zones are.",
    "description": "Large cloud operations partition operations into geographical regions for fault tolerance and to offer localized performance advantages. A region is not a monolithic data center but rather a geographical area of presence. The actual data centers in each region are availability zones. Each region will usually have two or more availability zones (AZs) for fault tolerance. The AZs are isolated locations within cloud data center regions that public cloud providers originate and operate. Each availability zone is a physically separate data center with its own redundant power and network connections."
  },
  {
    "id": 512,
    "topic_id": 200,
    "title": "Know the key concepts of creating and executing a cloud deployment.",
    "description": "Cloud migrations are a key exam topic and the primary focus of this chapter. It is critical that you understand all the project topics concerning the preparation and deployment process. I suggest that you read this chapter several times until you fully understand the migration process."
  },
  {
    "id": 513,
    "topic_id": 200,
    "title": "Differentiate between the cloud service models.",
    "description": "Know what community, hybrid, private, and public clouds are. By combining your knowledge of the deployment models and the service models introduced in Chapter 1, you\u2019ll have a good foundation to do well on the exam."
  },
  {
    "id": 514,
    "topic_id": 200,
    "title": "Understand and differentiate the technical concepts of performing a migration.",
    "description": "Know the CPU and memory sizing topics. Memory topics such as bursting, ballooning, and overcommitments are all fair game for exam questions. CPU topics that you must know are hyperthreading, virtualization extensions in the CPU silicon, performance, and dedicated versus shared hardware resources."
  },
  {
    "id": 515,
    "topic_id": 200,
    "title": "Explain the storage technologies used in cloud computing.",
    "description": "Storage plays an important role in running your operations in the cloud, and you learned about the various types of storage, redundancy, provisioning models, security, availability, and redundancy. Storage is a key exam topic."
  },
  {
    "id": 516,
    "topic_id": 200,
    "title": "Identify and be able to describe how to perform workload migrations.",
    "description": "Know what V2V, P2V, and V2P migrations are and when you may need to perform each one. Understand the issues involved with storage migrations as well as how to determine whether an online or offline migration will be required."
  },
  {
    "id": 517,
    "topic_id": 200,
    "title": "Explain the different types of user and machine authentication and authorization techniques.",
    "description": "Be able to identify and explain the different types of authentication. These include local, federated, directory servers, SSO, and MFA. Be able to select the best authentication method for a given set of requirements."
  },
  {
    "id": 518,
    "topic_id": 200,
    "title": "Explain the network services used in cloud computing.",
    "description": "Core network services in the cloud include DNS, DHCP, TLS certificates, load balancers, firewalls, and IDS/IPS. These are all critical components for any cloud deployment model and application. Read this section over several times until you fully understand the basics of each technology and be able to identify when, where, and why each is used in the cloud network."
  },
  {
    "id": 519,
    "topic_id": 200,
    "title": "Know about cloud security compliance.",
    "description": "Know that a company\u2019s security policy is an internal document that outlines its security posture and lists all topics related to security."
  },
  {
    "id": 520,
    "topic_id": 200,
    "title": "Understand that companies must meet certain regulatory compliance statutes.",
    "description": "Know that HIPAA compliance is required for the processing and storing of medical data, that PCI DSS compliance is required for credit card processing, and that there are a range of U.S. federal cloud requirements such as DIACAP, FedRAMP, and FIPS 140-2."
  },
  {
    "id": 521,
    "topic_id": 200,
    "title": "Understand compliance.",
    "description": "Know that even if a cloud provider is compliant with a regulation, that compliance doesn\u2019t automatically extend to your organization. You must architect and implement your systems to the relevant compliance standards. For example, if a cloud provider is PCI DSS compliant but you leave credit card numbers sitting out in a publicly accessible object storage bucket, you won\u2019t pass a compliance audit."
  },
  {
    "id": 522,
    "topic_id": 200,
    "title": "Be able to identify data encryption types and techniques.",
    "description": "Know what IPsec is and the difference between transport and tunnel modes. Understand ciphers, the public key infrastructure, encryption types, and common implementations of encryption technologies such as TLS and VPNs."
  },
  {
    "id": 523,
    "topic_id": 200,
    "title": "Know the various remote access technologies.",
    "description": "Common remote access protocols include L2TP, PPTP, and GRE."
  },
  {
    "id": 524,
    "topic_id": 200,
    "title": "Understand the devices that need to be hardened in your cloud fleet.",
    "description": "Disable all unused services, deploy a firewall, implement antivirus protection, keep your servers patched and up to date, and shut down default user accounts."
  },
  {
    "id": 525,
    "topic_id": 200,
    "title": "Be able to explain authentication and authorization.",
    "description": "Understand the concepts of user and service accounts and groups. Know the difference between authentication and authorization. Authentication is concerned with identifying a user, whereas authorization deals with what that user is allowed to do."
  },
  {
    "id": 526,
    "topic_id": 200,
    "title": "Know who has security responsibility for the various cloud services\u2019 models.",
    "description": "For IaaS, you have full responsibility from the operating system up to the application level, and the cloud service provider maintains responsibility from the hypervisor down to the cloud data center infrastructure. PaaS allows the cloud service provider to take responsibility for everything except the application. In the SaaS model, the cloud service provider takes security responsibility up to the application level. However, it is important to understand that ultimately you are responsible for your data and for meeting compliance requirements."
  },
  {
    "id": 527,
    "topic_id": 200,
    "title": "Know the different types of access controls.",
    "description": "Be able to identify and understand the many types of access control, including mandatory, discretionary, nondiscretionary, multifactor, and single sign-on."
  },
  {
    "id": 528,
    "topic_id": 200,
    "title": "Know what data classification is.",
    "description": "Data classification is the organization of data into different tiers or categories for the purpose of making data available as required and to meet regulatory requirements, mitigate and manage risk, and secure data. Data can be organized into any defined category and managed according to that category\u2019s needs. Metadata is data that is attached to a file and can be thought of as a tag that explains, categorizes, or classifies that data. Metadata allows the data to be tracked as a group and be searched, and it can reduce duplication of like data, which can help reduce or even eliminate storage requirements."
  },
  {
    "id": 529,
    "topic_id": 200,
    "title": "Understand segmentation of cloud resources.",
    "description": "Cloud segmentation is the process of dividing your cloud deployment into sections to allow for granular security policies to be applied. By applying segmentation to your cloud deployment, you can implement a multilayered security approach that aligns with a defense-in-depth security model."
  },
  {
    "id": 530,
    "topic_id": 200,
    "title": "Know how to implement encryption in the cloud.",
    "description": "There are regulations and corporate policies that require data to be encrypted not only as it is transmitted across the network but also when it is in a storage system. Be able to read cenario-based questions and determine the type of encryption application that is applicable."
  },
  {
    "id": 531,
    "topic_id": 200,
    "title": "Understand multifactor authentication.",
    "description": "Multifactor authentication includes something you know (username and password) and something you have (an MFA device that displays a changing numerical token). When authenticating to systems, you will be prompted for a username and password and also be asked to type in the number given on the rotating token generator. Multifactor authentication offers a higher level of security than using a simple username/password combination."
  },
  {
    "id": 532,
    "topic_id": 200,
    "title": "Understand and differentiate regulatory compliance issues as they relate to the implementation of cloud security.",
    "description": "Be able to answer questions related to the implementation of regulatory and compliance requirements. Compliance starts early in the planning process of a cloud deployment and continues through the design, implementation, and validation phases."
  },
  {
    "id": 533,
    "topic_id": 200,
    "title": "Know the basics of automation and programmable interfaces.",
    "description": "It\u2019s possible to automate many of your ongoing cloud security operations. Security automation can allow code to replace many of the processes that had to be performed manually in the past. Questions that reference APIs, REST, JSON, or CLI are likely related to programmability and automation. You do not need to know how to program, but you do need to understand the concepts behind how APIs work."
  },
  {
    "id": 534,
    "topic_id": 200,
    "title": "Identify the different ways that security is implemented.",
    "description": "You may be required to identify different methods of implementing security. Examples include using orchestration systems, scripting techniques, and customized automation systems."
  },
  {
    "id": 535,
    "topic_id": 200,
    "title": "Know security services.",
    "description": "For the exam, you should understand the basic operations of firewalls, intrusion detection and prevention services, host-based intrusion, and common antivirus and antimalware software implementations. Be able to differentiate between IPS and IDS."
  },
  {
    "id": 536,
    "topic_id": 200,
    "title": "Know the common systems that need ongoing patch management.",
    "description": "The most common systems that are operating in the cloud are hypervisors, virtual machines, virtual appliances, software applications, and clustered systems. Also, networking components, such as switches, routers, load balancers, firewalls, NAT systems, and many others, will need to be patched to remain current and secure. Storage systems are also included here."
  },
  {
    "id": 537,
    "topic_id": 200,
    "title": "Differentiate between the different types of updates.",
    "description": "You can expect the exam to ask you questions about the different types of updates. An update procedure will be described in the question, and you\u2019ll need to identify what type of update it is. It\u2019s important that you be able to distinguish the differences between these types, such as blue-green, rolling updates, production, development, and QA."
  },
  {
    "id": 538,
    "topic_id": 200,
    "title": "Understand automation and the basic support operations that can be performed.",
    "description": "Automation systems play an important role in cloud computing. You need to know what runbooks, workflow, and orchestration systems are."
  },
  {
    "id": 539,
    "topic_id": 200,
    "title": "Know virtualization operations that are common in the ongoing support and maintenance of cloud operations.",
    "description": "Be able to answer exam questions concerning what a snapshot is and its purpose. Know the differences between snapshots (which are backups) and cloning (which is a master copy of an image that is used for repetitive deployments)."
  },
  {
    "id": 540,
    "topic_id": 200,
    "title": "Explain the storage operations in ongoing cloud maintenance.",
    "description": "You can expect that the exam will test you on your storage knowledge since it\u2019s a critical component of all cloud operations. Know the types of backups and be able to identify questions that differentiate between full, differential, and incremental backups."
  },
  {
    "id": 541,
    "topic_id": 200,
    "title": "Differentiate between the different types of backup targets.",
    "description": "Prepare for scenario questions that may describe a particular backup target solution and be able to select the correct type. Replicates, local, and remote are all common target types."
  },
  {
    "id": 542,
    "topic_id": 200,
    "title": "Understand backup and restore topics.",
    "description": "Know that there are service level agreements that address backup operations, that backups can be scheduled for automated operations, and that service providers offer many different configuration options."
  },
  {
    "id": 543,
    "topic_id": 200,
    "title": "Know the key concepts of disaster recovery.",
    "description": "Know the DR responsibilities of the provider and of your company. Understand what an SLA is and how it defines responsibilities. Know that the RTO is the time it takes to restore operations after a disaster and that the RPO is the point in time that data is recovered and restored."
  },
  {
    "id": 544,
    "topic_id": 200,
    "title": "Know what business continuity planning is and the components to be considered.",
    "description": "You may be asked about business continuity planning in a scenario that gives background information, and you have to identify what the question is looking for. Know that the business continuity plan is a corporate document that defines the ability of a company to survive a disaster and that it is used to create a disaster recovery plan to meet those objectives."
  },
  {
    "id": 545,
    "topic_id": 200,
    "title": "Understand the key components of ongoing maintenance.",
    "description": "A maintenance plan includes scheduling and maintenance windows. Understand that automation and orchestration can assist in repeatable maintenance operations."
  },
  {
    "id": 546,
    "topic_id": 200,
    "title": "Explain disaster recovery (DR) designs.",
    "description": "Study the DR models of hot site, warm site, and cold site and be able to distinguish the use cases for each one. Be able to identify the pros and cons of each approach."
  },
  {
    "id": 547,
    "topic_id": 200,
    "title": "Understand ongoing maintenance of different cloud services.",
    "description": "The exam objectives require knowledge of certain ongoing maintenance tasks that you are expected to know and identify. These include working with log files, compressing data, dealing with inactive accounts, working with stale DNS, and dealing with outdated firewall and access control policies. Other maintenance topics that you can be expected to know relate to orphaned and unused resources and how to identify and reclaim them."
  },
  {
    "id": 548,
    "topic_id": 200,
    "title": "Know what a metric is.",
    "description": "A metric is a measurement of some property of a resource, such as CPU utilization or requests per second. By collecting metrics, you can determine trends in your usage. The exam may present a long, scenario-based question that can be solved by focusing on metrics and what they are used for."
  },
  {
    "id": 549,
    "topic_id": 200,
    "title": "Understand baselines and anomalies.",
    "description": "A baseline is the range of metrics collected during normal operations, and values above or below the baseline are anomalies. You may encounter questions that test your ability to distinguish between these two terms."
  },
  {
    "id": 550,
    "topic_id": 200,
    "title": "Be able to explain alerting, methods, triggers, and notifications.",
    "description": "When a metric falls outside a defined threshold, it can trigger an alert. You can configure a variety of responses to an alert, including notifications such as email or text messages. Particular events, such as terminating a VM, can also trigger alerts."
  },
  {
    "id": 551,
    "topic_id": 200,
    "title": "Understand cloud management support agreements and responsibilities.",
    "description": "Cloud companies offer a basic support plan that is usually free of charge but limited in scope. Premium service agreements are offered with varying levels of support commitments. You may be given an example of an outage and asked whether the customer or cloud provider is responsible."
  },
  {
    "id": 552,
    "topic_id": 200,
    "title": "Know what change management and configuration management are.",
    "description": "Configuration management is the tracking and documentation of ongoing changes to device configurations, including what changes were performed, by whom, and at what time. Change management is a complete process that monitors and manages all changes that are made to your cloud fleet. For the exam, understand the role of the change advisory board and the approvals documentation that are part of an effective change management plan."
  },
  {
    "id": 553,
    "topic_id": 200,
    "title": "Be able to identify when and how to scale cloud resources.",
    "description": "You may be asked how and when to add or remove cloud computing capacity. Know the differences among cloud bursting, horizontal scaling, and vertical scaling. Also, be able to explain the limitations of each."
  },
  {
    "id": 554,
    "topic_id": 200,
    "title": "Understand the application lifecycle.",
    "description": "For the exam, you should be able to answer questions that outline the life of an application from its initial design, deployment, updates, migrations, feature changes, replacement, and finally retirement."
  },
  {
    "id": 555,
    "topic_id": 200,
    "title": "Know how organizational changes may impact cloud resources.",
    "description": "Corporate mergers, acquisitions, spin-offs, and legal and regulatory changes can necessitate changes to your cloud resources. Even if your organization isn\u2019t directly affected by such changes, they may require your cloud provider to make changes that do affect you."
  },
  {
    "id": 556,
    "topic_id": 200,
    "title": "Understand user accounts.",
    "description": "User account management includes authentication, authorization, federations, and single sign-on systems. Other topics that are fair game for the exam include account management such as new users, password complexity, policies, removal of old accounts, and permission settings. User accounts are an important part of ongoing cloud management, and you should expect several questions that test your knowledge of the topic."
  },
  {
    "id": 557,
    "topic_id": 200,
    "title": "Know what baselines are and how they are created.",
    "description": "For the exam, you may be given long scenario questions that pertain to measuring a system to determine its normal operational state or the process of monitoring objects, such as CPU utilization, and you must be able to identify that the question concerns baselines."
  },
  {
    "id": 558,
    "topic_id": 200,
    "title": "Understand service level agreements and their purpose.",
    "description": "SLAs are service provider documents that outline detailed performance metrics that the provider guarantees to meet for their customers. Items such as downtime, latency, compliance, and division of responsibilities are all included. The exam may detail what is included, and you\u2019ll be required to identify that it is the SLA that is being referred to in the question."
  },
  {
    "id": 559,
    "topic_id": 200,
    "title": "Know what objects and metrics are.",
    "description": "Objects are anything that can be measured and on which data can be collected. Metrics are the actual data. You may be given a long scenario question that, for example, asks about a performance issue of a server and how data can be collected and analyzed to determine what the problem is."
  },
  {
    "id": 560,
    "topic_id": 200,
    "title": "Differentiate between reporting options.",
    "description": "For the exam, know that there are many different types of reporting options available for management, marketing, accounting, and operations. Know that these may include policies, SLA attainment, elasticity, connectivity, latency, capacity and utilization, cost accounting, incidents, and availability. You may be asked to identify which reporting is being discussed in an exam question."
  },
  {
    "id": 561,
    "topic_id": 200,
    "title": "Be able to identify use cases for vertical and horizontal scaling.",
    "description": "Given a scenario, you may be asked to identify a performance issue and determine what steps to take to remediate the problem. Vertical scaling is expanding the capacity of a server, whereas horizontal scaling is adding additional servers to your fleet. Read each question carefully to understand fully what the performance issue is and the application requirements to be able to identify if vertical or horizontal scaling is the correct solution."
  },
  {
    "id": 562,
    "topic_id": 200,
    "title": "Know the key concepts of troubleshooting.",
    "description": "Keep up-to-date documentation of your network, backups of current configurations, and current diagrams. You may be asked questions about planning for outages or basic troubleshooting preparedness and what records you should have available."
  },
  {
    "id": 563,
    "topic_id": 200,
    "title": "Know the basics of common problems that require troubleshooting.",
    "description": "Although there are limitless issues that may require troubleshooting, for the exam, be prepared for scenario-based questions that ask you to select a specific service from multiple choices."
  },
  {
    "id": 564,
    "topic_id": 200,
    "title": "Explain capacity-related issues and how to identify and resolve them.",
    "description": "The exam may quiz you on capacity starvation and verify that you know how to troubleshoot issues such as CPU, memory, network, licensing, API requests, or storage limitations and then how to resolve the problems once they have been identified."
  },
  {
    "id": 565,
    "topic_id": 200,
    "title": "Know how to identify and troubleshoot workflow issues.",
    "description": "Workflows include account mismatches; failures in the change management process; and critical changes in IP, DNS, server names, or locations. The exam presents these topics as scenario questions, where you are expected to identify the underlying issues."
  },
  {
    "id": 566,
    "topic_id": 200,
    "title": "Understand automation and orchestration.",
    "description": "You will be expected to know how to validate that the automation and orchestration systems perform as expected and how to troubleshoot any problems. You need to understand that these systems are often the responsibility of the service provider and that you need to rely on them to perform any troubleshooting."
  },
  {
    "id": 567,
    "topic_id": 200,
    "title": "Know the various network connectivity issues and how to troubleshoot them.",
    "description": "Common network issues on which you can expect to be tested include IP addressing such as misconfigured subnet masks, default gateways, routing, and DNS. Know at a basic level what QoS is and the symptoms of network saturation. Given a problem, be able to identify the most likely root cause. For example, being able to connect to a remote site by its IP address but not by its domain name suggests a DNS problem."
  },
  {
    "id": 568,
    "topic_id": 200,
    "title": "Know how to identify networking issues.",
    "description": "Be able to identify and perform basic troubleshooting of network connectivity failures. This can include using command-line troubleshooting tools, investigating log files, and monitoring systems to gather information on the reported issue. There may be a long scenario where you are given a large amount of detail, and you should be able to discard what does not apply and select from the answers given the core processes to identify the problem."
  },
  {
    "id": 569,
    "topic_id": 200,
    "title": "Be able to diagnose user account issues.",
    "description": "You may see questions on the exam with a description of a user not being able to access the cloud and a brief explanation of the symptoms. You need to be able to distill the problem to common user issues such as account lockouts, authentication and authorization problems, and account federation problems."
  },
  {
    "id": 570,
    "topic_id": 200,
    "title": "Describe the process of identifying certificate problems.",
    "description": "Know that security certificates have expiration dates and that you need to renew them prior to that time. Certificates must also match the domain name(s) that they\u2019re used with. Certificate management can be a fully managed cloud service or handled internally by your organization. You may be asked what steps to take when troubleshooting a certificate problem and to identify the correct answer offered given the scenario."
  },
  {
    "id": 571,
    "topic_id": 200,
    "title": "Identify types of attacks.",
    "description": "You may be given an example of an attack, and you should be able to identify whether it is originating internally or externally. Also, know the distinct signs of denial-of-service and social engineering attacks."
  },
  {
    "id": 572,
    "topic_id": 200,
    "title": "Explain remote access technologies and uses.",
    "description": "Know how to access cloud resources. The Remote Desktop Protocol is commonly used for administering Windows servers. Remote command-line access uses the Secure Shell protocol because it is encrypted and more secure than Telnet. Console ports are used for command-line serial port access for remote configuration and monitoring. Many devices offer a web-based configuration interface that can be accessed using the HTTPS protocol, much like accessing websites on the Internet."
  },
  {
    "id": 573,
    "topic_id": 200,
    "title": "Summarize the various approaches to troubleshooting.",
    "description": "Troubleshooting methods include top-down, bottom-up, and divide and conquer."
  },
  {
    "id": 574,
    "topic_id": 200,
    "title": "Know how to use a troubleshooting methodology.",
    "description": "You may be presented with a question where a description is given of a troubleshooting step and you are asked to identify which step in the troubleshooting process is being used. Examples are identifying the problem, establishing a probable theory of the cause, testing the theory, establishing a plan of action to resolve the problem, and implementing the solution. The final step is documenting the findings, actions, and outcomes."
  }
];
